import { Component } from "react";
import { connect } from "react-redux";
import { userAssignedBoards } from "../../../store/selectors/userAssignedBoards";
import withRouter from "../../lib/withRouter";
import { getBoardsData, getBranchesLatest } from "../../../store/actions";
import Service from '../../services';
import Authentication from '../../session';
import { Button } from "primereact/button";
import ClassetDropdown from "../../../classetComponents/classetDropDown";
import { AddIcon2, FileAttachmentIcon, MailIcon } from "../../svgIcons";
import { getFormFields, isFormValid, onDropDownChange, onEmailChange, onTextChange } from "../../../utile/formHelper";
import ClassetInputText from "../../../classetComponents/classetInputText";
import ClassetCalendar from "../../../classetComponents/classetCalender";
import ClassetTextArea from "../../../classetComponents/classetTextArea";
import FileUpload from "../../fileUpload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import _, { cloneDeep } from 'lodash';
import { InputSwitch } from "primereact/inputswitch";
import { baseUrlAdmin } from '../../../store/apiConstants';
import { trimObj } from "../../../utile";
import LoadingComponent from "../../loadingComponent";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { paymentModes } from '../../../constants';
import FeeReciept from '../receipt';
import Axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import asymmetricEncryptionUtils from "../../../utils/asymmetricEncryptionUtils";
// import NTTPaymentComponent from '../../NTTPaymentComponent/NTTPaymentComponent';
import NTTPaymentComponent from '../../financeManagement/NTTPaymentComponent';



import countryPhoneCodes from '../../../constants/countryPhoneCodes.json';
import countries from '../../../constants/countries.json';
import motherTongue from '../../../constants/motherTongue.json';
import castes from '../../../constants/castes.json';
import religions from '../../../constants/religions.json';
import states from '../../../constants/states.json';
import districts from '../../../constants/districts.json';
import cityOrDist from '../../../constants/cityOrDist.json';
import area from '../../../constants/area.json';
import gradesEnum from '../../../constants/grades.json';


const createFields = require('./collectFee.json');
const createRegistrationFields = require('./registrationCreate.json');
const formFields = createRegistrationFields
const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';
const profilesBucket = process.env.REACT_APP_PROFILES_BUCKET || 'classet-profiles-old';

class CreateRegistration extends Component {


    constructor(props) {
        super(props);
        this.formFields = getFormFields(createRegistrationFields);
        this.payformFields = getFormFields(createFields);

        const transformedCountryPhoneCodes = countryPhoneCodes.map(country => ({
            label: `${country.country} (+${country.code})`,
            value: country.code,
            country: country.country,
            iso: country.iso
        }));

        const transformedMotherTongue = motherTongue.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        const transformedCastes = castes.map(caste => ({
            label: caste.label,
            value: caste.value
        }));

        const transformedReligions = religions.map(religion => ({
            label: religion.label,
            value: religion.value
        }));

        const transformedCountries = countries.map(country => ({
            name: country.name,
            code: country.code
        }));

        const transformedStates = states.map(state => ({
            label: state.label,
            value: state.value
        }));

        const transformedCityOrDist = cityOrDist.map(city => ({
            label: city.label,
            value: city.value
        }));

        const transformedArea = area.map(area => ({
            label: area.label,
            value: area.value
        }));

        // Transform grades from grades.json for classStudyingDrp
        const transformedGrades = Object.entries(gradesEnum).map(([label, value]) => ({
            label: label,
            value: value
        }));

        const isEditing = this.props?.selectedEnquiry?._id;

        // In constructor, update the initialAddressData section to include academicYearCode:
        let initialAcademicData = {
            academicYearCode: ''
        };

        // Check if we have academic year code data for registration
        if (this.props?.editRegistrationForm?.academicYearCode) {
            initialAcademicData.academicYearCode = this.props.editRegistrationForm.academicYearCode;
        } else if (this.props?.editRegistrationForm?.application?.academicYearCode) {
            initialAcademicData.academicYearCode = this.props.editRegistrationForm.application.academicYearCode;
        } else if (this.props?.editRegistrationForm?.application?.enquiry?.academicYearCode) {
            initialAcademicData.academicYearCode = this.props.editRegistrationForm.application.enquiry.academicYearCode;
        }

        // Fix the parents initialization
        let initialParents = [
            {
                parentType: '',
                parentName: '',
                qualification: '',
                profession: '',
                countryCode: '',
                parentContact: '',
                parentEmailId: '',
            }
        ];
        // Fix the siblings initialization
        let initialSiblings = [
            { name: "", gender: "", classStudying: "", schoolStudying: "" }
        ];

        // **NEW: Initialize address fields**
        let initialAddressData = {
            addressLine: '',
            pinCode: '',
            state: '',
            cityOrDist: ''
        };

        // **NEW: Initialize transport fields**
        let initialTransportData = {
            transportRequired: false,
            requestedStop: ''
        };
        // Check if we have transport data for registration
        if (this.props?.editRegistrationForm?.transportRequired !== undefined) {
            initialTransportData = {
                transportRequired: this.props.editRegistrationForm.transportRequired,
                requestedStop: this.props.editRegistrationForm.requestedStop || ''
            };
        } else if (this.props?.editRegistrationForm?.application?.transportRequired !== undefined) {
            initialTransportData = {
                transportRequired: this.props.editRegistrationForm.application.transportRequired,
                requestedStop: this.props.editRegistrationForm.application.requestedStop || ''
            };
        } else if (this.props?.editRegistrationForm?.application?.enquiry?.transportRequired !== undefined) {
            initialTransportData = {
                transportRequired: this.props.editRegistrationForm.application.enquiry.transportRequired,
                requestedStop: this.props.editRegistrationForm.application.enquiry.requestedStop || ''
            };
        }

        // Check if we have registration data with parents
        if (this.props?.editRegistrationForm?.parents?.length > 0) {
            initialParents = this.props.editRegistrationForm.parents;
        } else if (this.props?.editRegistrationForm?.application?.parents?.length > 0) {
            initialParents = this.props.editRegistrationForm.application.parents;
        } else if (this.props?.editRegistrationForm?.application?.enquiry?.parents?.length > 0) {
            initialParents = this.props.editRegistrationForm.application.enquiry.parents;
        }

        // Check if we have registration data with siblings
        if (this.props?.editRegistrationForm?.siblings?.length > 0) {
            initialSiblings = this.props.editRegistrationForm.siblings;
        } else if (this.props?.editRegistrationForm?.application?.siblings?.length > 0) {
            initialSiblings = this.props.editRegistrationForm.application.siblings;
        } else if (this.props?.editRegistrationForm?.application?.enquiry?.siblings?.length > 0) {
            initialSiblings = this.props.editRegistrationForm.application.enquiry.siblings;
        }

        // **NEW: Check if we have address data for registration**
        if (this.props?.editRegistrationForm?.addressLine) {
            initialAddressData = {
                addressLine: this.props.editRegistrationForm.addressLine || '',
                pinCode: this.props.editRegistrationForm.pinCode || '',
                state: this.props.editRegistrationForm.state || '',
                cityOrDist: this.props.editRegistrationForm.cityOrDist || ''
            };
        } else if (this.props?.editRegistrationForm?.application?.addressLine) {
            initialAddressData = {
                addressLine: this.props.editRegistrationForm.application.addressLine || '',
                pinCode: this.props.editRegistrationForm.application.pinCode || '',
                state: this.props.editRegistrationForm.application.state || '',
                cityOrDist: this.props.editRegistrationForm.application.cityOrDist || ''
            };
        } else if (this.props?.editRegistrationForm?.application?.enquiry?.addressLine) {
            initialAddressData = {
                addressLine: this.props.editRegistrationForm.application.enquiry.addressLine || '',
                pinCode: this.props.editRegistrationForm.application.enquiry.pinCode || '',
                state: this.props.editRegistrationForm.application.enquiry.state || '',
                cityOrDist: this.props.editRegistrationForm.application.enquiry.cityOrDist || ''
            };
        }


        this.state = {

            isLoading: false,
            feePlans: [],
            admissionType: [],
            payFeeFormData: this.payformFields.data,

            countryPhoneCodes: transformedCountryPhoneCodes,
            motherTongue: transformedMotherTongue,
            castes: transformedCastes,
            religions: transformedReligions,
            countries: transformedCountries,
            state: transformedStates,
            cityOrDist: transformedCityOrDist,
            area: transformedArea,
            parents: initialParents,
            parentValidations: [{}], // Validation state for each parent
            siblings: initialSiblings,

            // Initialize registration with all data
            registration: this.props?.editRegistrationForm?._id ? {
                ...this.props.editRegistrationForm,
                ...initialAddressData,
                ...initialTransportData,
                ...initialAcademicData
            } : {
                ...this.formFields.data,
                ...initialAddressData,
                ...initialTransportData,
                ...initialAcademicData
            },




            govtIdTypes: [
                { label: "Aadhaar Card", value: "aadhaar" },
                { label: "Passport", value: "passport" },
                { label: "Other", value: "other" }
            ],

            gender: [
                { label: 'Male', value: 'male' },
                { label: 'Female', value: 'female' },
                { label: 'Other', value: 'other' }
            ],
            parentTypes: [
                { label: 'Father', value: 'Father' },
                { label: 'Mother', value: 'Mother' },
                { label: 'Guardian', value: 'Guardian' }
            ],

            previousBoards: [
                { label: "Central Board of Secondary Education (CBSE)", value: "CBSE" },
                { label: "Indian Certificate of Secondary Education (ICSE)", value: "ICSE" },
                { label: "International Baccalaureate (IB)", value: "IB" },
                { label: "Cambridge Assessment International Education (IGCSE)", value: "IGCSE" },
                { label: "State Board", value: "State" },
                { label: "National Institute of Open Schooling (NIOS)", value: "NIOS" },
                { label: "Council for the Indian School Certificate Examinations (CISCE)", value: "CISCE" },
                { label: "Other", value: "Other" },
            ],

            payFee: this.payformFields.data,
            formValidations: this.formFields.formValidations,
            payFormValidations: this.payformFields.formValidations,
            addDifferentialFeeAllow: false,
            selectedEnquiry: {},
            isAddApplication: false,
            academicCategory: [],
            isEdit: false,
            boards: [],
            isExam: false,
            createdId: null,
            isShowReceipt: false,
            isRegistrationFeePaid: false,
            receiptInfo: {},
            isShowPayFeeButton: false,
            paymentModes: [],
            isOpenPayFeeDailog: false,
            transctionId: null,
            feePayInfo: {},
            partialPayment: false,


            genderData: [
                { label: "Male", value: "male" },
                { label: "Female", value: "female" }
            ],
            classStudyingDrp: transformedGrades,
            showNTTPayment: false,
            nttPaymentData: null,
            selectedClassesList: [],
            dob: null,
            ageCriteriaInfo: [],
            admissionSettingsInfo: null
        };
        this.service = new Service();
    }

    getAdmissionSettingsInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/process?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ admissionSettingsInfo: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    };

    // Helper method to check if registration fee is required
    checkIfRegistrationFeeRequired = async () => {
        try {
            this.setState({ isLoading: true });
            let url = `${baseUrlAdmin}/application-fee/filter`;
            let payload = {
                "isActive": true,
                "academicYear": this.state.registration?.academicSession,
                "orgId": this.state.registration?.orgId,
                "board": this.state.registration?.board,
                "grade": this.state.registration?.grade,
                "admissionStep": "Registration"
            };

            const res = await this.service.post(url, payload, true);
            this.setState({ isLoading: false });

            if (res?.res?.status && res.status) {
                return (res?.res?.data && Object.keys(res?.res?.data).length) ? true : false;
            } else if (res?.status === false) {
                return (res?.res?.data && Object.keys(res?.res?.data).length) ? true : false;
            } else {
                return false;
            }
        } catch (e) {
            this.setState({ isLoading: false });
            console.error('Error checking if registration fee is required:', e);
            return false;
        }
    };

    // Check if registration fee is paid and show payment dialog if not
    checkApplicationFeePaidStatus = async () => {
        try {
            // First check if registration fee is configured by calling handlePayFee
            // This will set isShowPayFeeButton based on whether fee exists
            await this.handlePayFee(false);

            // First check if we have a registration ID
            if (this.props?.editRegistrationForm?._id || this.state.registration?._id) {
                const registrationId = this.props?.editRegistrationForm?._id || this.state.registration?._id;

                // Use setTimeout to ensure state has been updated before checking
                setTimeout(async () => {
                    // If no fee is configured, don't show the dialog
                    if (!this.state.isShowPayFeeButton) {
                        console.log("No registration fee configured. Skipping fee dialog.");
                        return;
                    }

                    console.log("Registration fee is configured. Checking payment status...");

                    // First check if we have a registration ID
                    if (this.props?.editRegistrationForm?._id || this.state.registration?._id) {
                        const registrationId = this.props?.editRegistrationForm?._id || this.state.registration?._id;

                        // Check fee payment status for existing registration
                        const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${registrationId}`;
                        const res = await this.service.get(url, true);

                        if (res && res.status && res.res.status) {
                            const receiptInfo = res.res.data;
                            const isFeePaid = receiptInfo?.isRegistrationFeePaid || false;

                            this.setState({ isRegistrationFeePaid: isFeePaid });

                            // If fee is not paid and we have fee configuration, show payment dialog
                            if (!isFeePaid) {
                                console.log("Fee not paid. Opening payment dialog...");
                                this.openDailogPayAppFee();
                            } else {
                                console.log("Fee already paid. Skipping dialog.");
                            }

                            if (isFeePaid) {
                                this.onSubmitApplication(true);
                            }
                        } else {
                            // Fee not paid, show dialog
                            console.log("Could not get fee status. Opening payment dialog...");
                            this.setState({ isRegistrationFeePaid: false });
                            this.openDailogPayAppFee();
                        }
                    } else {
                        // For new registrations, show dialog as fee is required
                        console.log("New registration. Opening payment dialog...");
                        this.setState({ isRegistrationFeePaid: false });
                        this.openDailogPayAppFee();
                    }
                }, 300); // Wait 300ms for state to update
            }
        } catch (error) {
            console.error('Error checking registration fee status:', error);
            this.setState({ isRegistrationFeePaid: false });
        }
    };

    // Wrapper method to conditionally check application fee status
    conditionallyCheckApplicationFeeStatus = async () => {
        try {
            // First check if registration fee is required
            const isFeeRequired = await this.checkIfRegistrationFeeRequired();

            if (isFeeRequired) {
                console.log('Registration fee is required, checking fee status...');
                await this.checkApplicationFeePaidStatus();
            } else {
                console.log('Registration fee is not required, skipping fee status check');
                // Set registration fee as paid since it's not required
                this.setState({
                    isRegistrationFeePaid: true,
                    isShowPayFeeButton: false
                });
                // Proceed to next step
                this.onSubmitApplication(true);
            }
        } catch (error) {
            console.error('Error in conditional fee status check:', error);
            // Fallback to checking fee status anyway
            await this.checkApplicationFeePaidStatus();
        }
    };

    async componentDidMount() {

        //Check if application fee is paid and show payment dialog if not paid
        // await this.checkApplicationFeePaidStatus();
        // this.openDailogPayAppFee();

        // Check for payment redirect from NTT gateway
        const urlParams = new URLSearchParams(window.location.search);
        const paymentStatus = urlParams.get('status');
        const txnId = urlParams.get('txnId');
        const atomTxnId = urlParams.get('atomTxnId');
        const referenceNo = urlParams.get('referenceNo');

        if (paymentStatus) {
            this.handlePaymentRedirect(paymentStatus, txnId, atomTxnId, referenceNo);
            return; // Don't continue with normal mount if handling payment redirect
        }

        const applicationId = await localStorage.getItem('applicationId')
        await this.getAdmissionSettingsInfo()
        this.props.getBranchesLatest()
        this.props.getBoardsData(true);
        await this.getAdmissionTypeDropdown()
        await this.getAcademicSessions()
        if (applicationId !== undefined && applicationId) {
            await this.getAdmissionInfo(applicationId)
        }
        if (this.props.editRegistrationForm?._id) {
            // Check if student is already enrolled
            try {
                const checkEnrollmentUrl = `${baseUrlAdmin}/admissions/complete-info?admissionId=${this.props.editRegistrationForm._id}`;
                const enrollmentResponse = await this.service.get(checkEnrollmentUrl, true);

                if (enrollmentResponse?.res?.data?.enrollment?.isEnrolled) {
                    // Student is already enrolled, prevent editing and redirect
                    this.toast?.show({
                        severity: 'warn',
                        summary: 'Student Already Enrolled',
                        detail: 'This student is already enrolled and cannot be edited from registration.',
                        life: 4000
                    });

                    setTimeout(() => {
                        this.props.navigate('/admission-registration');
                    }, 2000);
                    return;
                }
            } catch (error) {
                console.error('Error checking enrollment status:', error);
            }

            // Set DOB in state if it exists - check multiple possible locations
            let dobValue = null;

            // Try to get DOB from various possible locations
            const possibleDobSources = [
                this.props.editRegistrationForm?.dob,
                this.props.editRegistrationForm?.registration?.dob,
                this.props.editRegistrationForm?.application?.dob,
                this.props.editRegistrationForm?.application?.enquiry?.dob
            ];

            for (const dobSource of possibleDobSources) {
                if (dobSource) {
                    const dobDate = new Date(dobSource);
                    // Check if the date is valid and not epoch (1/1/1970)
                    if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                        dobValue = dobDate;
                        console.log('🔍 Registration Edit - DOB loaded from source:', dobSource, 'Result:', dobValue);
                        break; // Stop at first valid DOB found
                    }
                }
            }

            if (!dobValue) {
                console.warn('⚠️ Registration Edit - No valid DOB found in editRegistrationForm');
            }

            // Extract all data for registration
            let parentsData = [];
            let siblingsData = [];
            let addressData = {};
            let transportData = {};
            let academicData = {};

            if (this.props.editRegistrationForm?.parents?.length > 0) {
                parentsData = this.props.editRegistrationForm.parents;
            } else if (this.props.editRegistrationForm?.application?.parents?.length > 0) {
                parentsData = this.props.editRegistrationForm.application.parents;
            } else if (this.props.editRegistrationForm?.application?.enquiry?.parents?.length > 0) {
                parentsData = this.props.editRegistrationForm.application.enquiry.parents;
            }

            if (this.props.editRegistrationForm?.siblings?.length > 0) {
                siblingsData = this.props.editRegistrationForm.siblings;
            } else if (this.props.editRegistrationForm?.application?.siblings?.length > 0) {
                siblingsData = this.props.editRegistrationForm.application.siblings;
            } else if (this.props.editRegistrationForm?.application?.enquiry?.siblings?.length > 0) {
                siblingsData = this.props.editRegistrationForm.application.enquiry.siblings;
            }

            // Extract address data
            if (this.props.editRegistrationForm?.addressLine) {
                addressData = {
                    addressLine: this.props.editRegistrationForm.addressLine,
                    pinCode: this.props.editRegistrationForm.pinCode,
                    state: this.props.editRegistrationForm.state,
                    cityOrDist: this.props.editRegistrationForm.cityOrDist
                };
            } else if (this.props.editRegistrationForm?.application?.addressLine) {
                addressData = {
                    addressLine: this.props.editRegistrationForm.application.addressLine,
                    pinCode: this.props.editRegistrationForm.application.pinCode,
                    state: this.props.editRegistrationForm.application.state,
                    cityOrDist: this.props.editRegistrationForm.application.cityOrDist
                };
            } else if (this.props.editRegistrationForm?.application?.enquiry?.addressLine) {
                addressData = {
                    addressLine: this.props.editRegistrationForm.application.enquiry.addressLine,
                    pinCode: this.props.editRegistrationForm.application.enquiry.pinCode,
                    state: this.props.editRegistrationForm.application.enquiry.state,
                    cityOrDist: this.props.editRegistrationForm.application.enquiry.cityOrDist
                };
            }

            // Load districts for edit mode if state is selected
            if (addressData.state) {
                const selectedState = addressData.state;
                const selectedStateDistricts = districts[selectedState] || [];
                this.setState({
                    cityOrDist: selectedStateDistricts
                });
            }

            // Extract transport data
            if (this.props.editRegistrationForm?.transportRequired !== undefined) {
                transportData = {
                    transportRequired: this.props.editRegistrationForm.transportRequired,
                    requestedStop: this.props.editRegistrationForm.requestedStop || ''
                };
            } else if (this.props.editRegistrationForm?.application?.transportRequired !== undefined) {
                transportData = {
                    transportRequired: this.props.editRegistrationForm.application.transportRequired,
                    requestedStop: this.props.editRegistrationForm.application.requestedStop || ''
                };
            } else if (this.props.editRegistrationForm?.application?.enquiry?.transportRequired !== undefined) {
                transportData = {
                    transportRequired: this.props.editRegistrationForm.application.enquiry.transportRequired,
                    requestedStop: this.props.editRegistrationForm.application.enquiry.requestedStop || ''
                };
            }

            // Extract academic year code
            if (this.props.editRegistrationForm?.academicYearCode) {
                academicData.academicYearCode = this.props.editRegistrationForm.academicYearCode;
            } else if (this.props.editRegistrationForm?.application?.academicYearCode) {
                academicData.academicYearCode = this.props.editRegistrationForm.application.academicYearCode;
            } else if (this.props.editRegistrationForm?.application?.enquiry?.academicYearCode) {
                academicData.academicYearCode = this.props.editRegistrationForm.application.enquiry.academicYearCode;
            }

            console.log('🔍 Registration Edit - Setting state with DOB:', dobValue);

            this.setState((prevState) => ({
                registration: {
                    ...prevState.registration,
                    ...this.props.editRegistrationForm,
                    ...addressData,
                    ...transportData,
                    ...academicData,
                    dob: dobValue // Ensure DOB is set in registration object
                },
                dob: dobValue, // Also set in state for easy access
                parents: parentsData.length > 0 ? parentsData : prevState.parents,
                siblings: siblingsData.length > 0 ? siblingsData : prevState.siblings,
                isEdit: true,
                isRegistrationFeePaid: true
            }), () => {
                // Call onChangeBranch and onChangeBoard after state is set to ensure DOB is available
                setTimeout(() => {
                    this.onChangeBranch(this.props?.editRegistrationForm?.branch);
                    this.onChangeBoard(this.props?.editRegistrationForm?.board);
                }, 100);
            })
        }

    }
    handlePayFee = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/application-fee/filter`;
        try {
            let payload = {
                "isActive": true,
                "academicYear": this.state.registration?.academicSession,
                "orgId": this.state.registration?.orgId,
                "board": this.state.registration?.board,
                "grade": this.state.registration?.grade,
                "admissionStep": "Registration"
            }
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                this.setState({ feePayInfo: res?.res?.data, isShowPayFeeButton: (res?.res?.data && Object.keys(res?.res?.data).length) ? true : false, isLoading: false }, () => this.onCheckFeePaidInfo(false));
            } else if (res?.status === false) {
                this.setState({ feePayInfo: res?.res?.data, isShowPayFeeButton: (res?.res?.data && Object.keys(res?.res?.data).length) ? true : false, isLoading: false }, () => this.onCheckFeePaidInfo(false));
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    };

    getAdmissionTypeDropdown = async () => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admission => ({
                    label: admission.categoryName,
                    value: admission._id
                }));

                this.setState({ academicCategory: result, isLoading: false });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };

    _onProgress = (filesInfo) => {

    }
    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Some error', detail: errMsg, life: 3000 });
    }

    addAttachment = (fieldName, fileName, data) => {
        this.setState((prevState) => (
            {
                registration: {
                    ...prevState.registration, [fieldName]: {
                        fileName,
                        storageBucket: data.Bucket,
                        storageKey: data.Key,
                        storageLocation: data.Location,
                    }
                }
            }
        ));
    }
    _onStudentPhotoSuccess = (fileName, data) => {
        this.addAttachment('studentPhoto', fileName, data);
    }

    _afterFilesUploaded = (files) => {

    }
    getAcademicSessions = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/academic-years/filter`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admission => ({
                    label: admission.academicCode,
                    value: admission._id
                }));
                this.setState({ academicSession: result, isLoading: false });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    onChangeBranch = (branchId) => {

        this.setState({
            boards: [], classes: [],
        });

        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;
        let filteredBoards = this.props.boards.filter(board => board.assignedBranches.includes(branchId));
        // Remove duplicates
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: filteredBoards,
            classes: [],
            boardId: '',
            selectedBoardName: '',
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: ''
        });
    };

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [],
            sections: []
        });
        const selectedBoard = this.state.boards && this.props.boards.find((board) => board.boardId === boardId);

        // Filter classes based on admission settings grades
        let classesInfo = this.state.admissionSettingsInfo?.grades || [];
        let finalClassesList = [];

        for (const sClass of classesInfo) {
            for (let i = 0; i < (selectedBoard?.classes?.length || 0); i++) {
                const classId = selectedBoard?.classes[i]?.classId;
                if (sClass === classId) finalClassesList.push(selectedBoard?.classes[i]);
            }
        }

        // Remove duplicates from grades list
        finalClassesList = this.removeDuplicates(finalClassesList, 'classId');

        this.setState({
            classes: [],
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            selectedClassesList: finalClassesList
        }, () => {
            // Fetch age criteria if branch is selected and DOB exists
            if (this.state.branchId && boardId) {
                this.getAgeCriteriaInfo(this.state.branchId, boardId, finalClassesList);
            } else if (finalClassesList.length > 0) {
                // If no age criteria, just show all filtered classes
                this.setState({ classes: finalClassesList });
            }
        });
    };

    onStateChange = (selectedState) => {
        // Get districts for selected state from districts.json
        const stateDistricts = districts[selectedState] || [];

        // Transform districts to dropdown format
        let transformedDistricts = stateDistricts.map(district => ({
            label: district,
            value: district
        }));

        // If no districts found for the selected state, add "Other" option
        if (transformedDistricts.length === 0) {
            transformedDistricts = [{ label: 'Other', value: 'Other' }];
        }

        this.setState(prevState => ({
            cityOrDist: transformedDistricts,
            registration: {
                ...prevState.registration,
                state: selectedState,
                cityOrDist: ''
            }
        }), () => {
            onDropDownChange(
                selectedState,
                'state',
                this,
                formFields,
                this.state.registration,
                this.state.formValidations,
                'registration',
                'formValidations'
            );
        });
    };

    getAdmissionInfo = async (applicationId) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/admissions/form?id=${applicationId}`;
        this.service.get(url, true).then(res => {
            if (res && res.status && res.res.status) {
                if (res.res.data && res.res.data.admissionRecords.length) {
                    // Handle nested array structure: admissionRecords[0][0] or admissionRecords[0]
                    let admissionRecord = res.res.data.admissionRecords[0];

                    // Check if it's a nested array and extract the actual record
                    if (Array.isArray(admissionRecord) && admissionRecord.length > 0) {
                        admissionRecord = admissionRecord[0];
                        console.log('📦 getAdmissionInfo (registration): Extracted from nested array structure');
                    }

                    // Extract parents, siblings, address, transport, and academic data
                    let parentsData = [];
                    let siblingsData = [];
                    let addressData = {};
                    let transportData = {};
                    let academicData = {};

                    if (admissionRecord?.enquiry?.parents?.length > 0) {
                        parentsData = admissionRecord.enquiry.parents;
                    } else if (admissionRecord?.parents?.length > 0) {
                        parentsData = admissionRecord.parents;
                    }

                    if (admissionRecord?.enquiry?.siblings?.length > 0) {
                        siblingsData = admissionRecord.enquiry.siblings;
                    } else if (admissionRecord?.siblings?.length > 0) {
                        siblingsData = admissionRecord.siblings;
                    }

                    // Extract address data from enquiry
                    if (admissionRecord?.enquiry?.addressLine) {
                        addressData = {
                            addressLine: admissionRecord.enquiry.addressLine,
                            pinCode: admissionRecord.enquiry.pinCode,
                            state: admissionRecord.enquiry.state,
                            cityOrDist: admissionRecord.enquiry.cityOrDist
                        };
                    } else if (admissionRecord?.addressLine) {
                        addressData = {
                            addressLine: admissionRecord.addressLine,
                            pinCode: admissionRecord.pinCode,
                            state: admissionRecord.state,
                            cityOrDist: admissionRecord.cityOrDist
                        };
                    }

                    // Load districts for the selected state
                    if (addressData.state) {
                        const selectedState = addressData.state;
                        const selectedStateDistricts = districts[selectedState] || [];

                        // Transform districts to dropdown format with {label, value}
                        let transformedDistricts = selectedStateDistricts.map(district => ({
                            label: district,
                            value: district
                        }));

                        // If no districts found for the selected state, add "Other" option
                        if (transformedDistricts.length === 0) {
                            transformedDistricts = [{ label: 'Other', value: 'Other' }];
                        }

                        // Update the cityOrDist dropdown options before setting state
                        this.setState({
                            cityOrDist: transformedDistricts
                        });
                    }

                    // Extract transport data from enquiry
                    if (admissionRecord?.enquiry?.transportRequired !== undefined) {
                        transportData = {
                            transportRequired: admissionRecord.enquiry.transportRequired,
                            requestedStop: admissionRecord.enquiry.requestedStop || ''
                        };
                    } else if (admissionRecord?.transportRequired !== undefined) {
                        transportData = {
                            transportRequired: admissionRecord.transportRequired,
                            requestedStop: admissionRecord.requestedStop || ''
                        };
                    }

                    // Extract academic year code from enquiry
                    if (admissionRecord?.enquiry?.academicYearCode) {
                        academicData.academicYearCode = admissionRecord.enquiry.academicYearCode;
                    } else if (admissionRecord?.academicYearCode) {
                        academicData.academicYearCode = admissionRecord.academicYearCode;
                    }

                    // Extract and validate DOB
                    let dobValue = null;
                    if (admissionRecord?.dob) {
                        const dobDate = new Date(admissionRecord.dob);
                        // Check if the date is valid and not epoch (1/1/1970)
                        if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                            dobValue = admissionRecord.dob;
                        }
                    } else if (admissionRecord?.enquiry?.dob) {
                        const dobDate = new Date(admissionRecord.enquiry.dob);
                        // Check if the date is valid and not epoch (1/1/1970)
                        if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                            dobValue = admissionRecord.enquiry.dob;
                        }
                    } else if (admissionRecord?.application?.dob) {
                        const dobDate = new Date(admissionRecord.application.dob);
                        // Check if the date is valid and not epoch (1/1/1970)
                        if (!isNaN(dobDate.getTime()) && dobDate.getFullYear() > 1970) {
                            dobValue = admissionRecord.application.dob;
                        }
                    }

                    this.setState({
                        isLoading: false,
                        registration: {
                            ...admissionRecord,
                            ...addressData,
                            ...transportData,
                            ...academicData,
                            dob: dobValue
                        },
                        dob: dobValue ? new Date(dobValue) : null,
                        parents: parentsData.length > 0 ? parentsData : this.state.parents,
                        siblings: siblingsData.length > 0 ? siblingsData : this.state.siblings
                    }, async () => {
                        this.onChangeBranch(this.state?.registration?.branch)
                        this.onChangeBoard(this.state?.registration?.board)
                        await this.conditionallyCheckApplicationFeeStatus()
                        await this.handlePayFee(false)
                        localStorage.removeItem('applicationId')
                    });
                }
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
            console.log(e);
        })
    }

    // Parent management methods
    addParent = () => {
        this.setState((prevState) => ({
            parents: [
                ...prevState.parents,
                {
                    parentType: '',
                    parentName: '',
                    qualification: '',
                    profession: '',
                    countryCode: '',
                    parentContact: '',
                    parentEmailId: '',
                }
            ],
            parentValidations: [...prevState.parentValidations, {}]
        }));
    };

    removeParent = (index) => {
        this.setState((prevState) => {
            const updatedParents = prevState.parents.filter((_, i) => i !== index);
            const updatedValidations = prevState.parentValidations.filter((_, i) => i !== index);
            return { parents: updatedParents, parentValidations: updatedValidations };
        });
    };

    // Contact number validation - exactly 10 digits
    onContactNumberChange = (value, fieldName) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 10);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 10) {
            validation = {
                isValid: false,
                errorMsg: 'Contact number must be exactly 10 digits'
            };
        } else if (numericValue && numericValue.length === 10) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            registration: {
                ...prevState.registration,
                [fieldName]: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Email validation with proper format check
    onEmailChangeWithValidation = (value, fieldName) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let validation = { isValid: true, errorMsg: '' };

        if (value && !emailRegex.test(value)) {
            validation = {
                isValid: false,
                errorMsg: 'Please enter a valid email address'
            };
        } else if (value) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            registration: {
                ...prevState.registration,
                [fieldName]: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Pincode validation - exactly 6 digits
    onPincodeChange = (value) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 6);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 6) {
            validation = {
                isValid: false,
                errorMsg: 'Pincode must be exactly 6 digits'
            };
        } else if (numericValue && numericValue.length === 6) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            registration: {
                ...prevState.registration,
                pinCode: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    pinCode: validation
                }
            }
        }));
    };

    onParentChange = (value, index, field) => {
        const updatedParents = [...this.state.parents];
        let validationError = null;

        // Apply validation for specific fields
        if (field === 'parentContact') {
            const numericValue = value.replace(/\D/g, '').slice(0, 10);
            updatedParents[index][field] = numericValue;

            if (numericValue && numericValue.length < 10) {
                validationError = 'Contact number must be exactly 10 digits';
            }
        } else if (field === 'parentEmailId') {
            updatedParents[index][field] = value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (value && !emailRegex.test(value)) {
                validationError = 'Please enter a valid email address';
            }
        } else {
            updatedParents[index][field] = value;
        }

        // Update parent validations
        const updatedParentValidations = [...this.state.parentValidations];
        if (!updatedParentValidations[index]) {
            updatedParentValidations[index] = {};
        }
        updatedParentValidations[index][field] = {
            isValid: !validationError,
            errorMsg: validationError || ''
        };

        const updatedRegistration = { ...this.state.registration };

        // Only sync the first parent's data to the registration object for validation and backward compatibility
        if (index === 0) {
            if (field === 'parentType') updatedRegistration.parentType = value;
            if (field === 'parentName') updatedRegistration.parentName = value;
            if (field === 'countryCode') updatedRegistration.countryCode = value;
            if (field === 'qualification') {
                console.log('🔍 Setting qualification:', value);
                updatedRegistration.qualification = value;
                updatedRegistration.parentQualification = value; // Backward compatibility
            }
            if (field === 'profession') {
                console.log('🔍 Setting profession:', value);
                updatedRegistration.profession = value;
                updatedRegistration.occupation = value; // Backward compatibility
            }

            if (field === 'parentContact') {
                // Use the validated/formatted value from updatedParents
                updatedRegistration.parentContact = updatedParents[0][field];
                updatedRegistration.contactNo = updatedParents[0][field]; // Backward compatibility
            }
            if (field === 'parentEmailId') {
                updatedRegistration.parentEmailId = value;
                updatedRegistration.emailId = value; // Backward compatibility
            }
        }

        console.log('🔍 Updated parents array:', updatedParents);
        console.log('🔍 Updated registration object:', {
            qualification: updatedRegistration.qualification,
            profession: updatedRegistration.profession,
            parentQualification: updatedRegistration.parentQualification,
            occupation: updatedRegistration.occupation
        });

        const updatedFormValidations = { ...this.state.formValidations };
        if (index === 0 && this.formFields.formValidations.fields[field]) {
            updatedFormValidations.fields[field] = {
                isValid: !validationError,
                errorMsg: validationError || ''
            };
        }

        this.setState({
            parents: updatedParents,
            parentValidations: updatedParentValidations,
            registration: updatedRegistration,
            formValidations: updatedFormValidations
        });
    };

    onChangeInput = (value, index, field, arr) => {
        if (arr === "siblings") {
            let data = cloneDeep(this.state.siblings)
            data[index][field] = value;
            this.setState({
                siblings: data
            })
        } else if (arr === "prevAcademicDetails") {
            let data = cloneDeep(this.state.prevAcademicDetails)
            data[index][field] = value;
            this.setState({
                prevAcademicDetails: data
            })
        }

    }

    onCliclAddSibling = (add, index) => {
        if (add) {
            let arrLength = this.state.siblings.length
            let lastObj = this.state.siblings[arrLength - 1]
            if (lastObj.name !== "") {
                this.setState((prevState) => {
                    return { siblings: [...prevState.siblings, { name: "", gender: "", classStudying: "", schoolStudying: "" }] }
                })
            } else {
                this.toast.show({ severity: 'error', summary: 'Please enter the sibling details', detail: '', life: 3000 });
            }
        }
        else if (add === false) {
            const { siblings } = this.state
            const newArr = [...siblings]
            newArr.splice(index, 1)
            this.setState({ siblings: newArr })
        }
    }

    onCliclAddPrevAcadamicDet = (bool, index) => {
        if (bool) {
            let arrLength = this.state.prevAcademicDetails.length
            let lastObj = this.state.prevAcademicDetails[arrLength - 1]
            if (lastObj.name !== "") {
                this.setState((prevState) => {
                    return { prevAcademicDetails: [...prevState.prevAcademicDetails, { name: "", classStudied: "", schoolStudied: "", percentageOrGpa: "" }] }
                })
            } else {
                this.toast.show({ severity: 'error', summary: 'Please enter the Previous academic details', detail: '', life: 3000 });
            }
        }
        else if (bool === false) {
            const { prevAcademicDetails } = this.state
            const newArr = [...prevAcademicDetails]
            newArr.splice(index, 1)
            this.setState({ prevAcademicDetails: newArr })
        }
    }

    onHandleCancelPayFee = () => {
        this.setState({
            isOpenPayFeeDailog: false,
            payFeeFormData: {},
            transctionId: null
        })
    }

    handleShowReceipt = (isContinue) => {
        const { receiptInfo } = this.state
        if (!isContinue) {
            this.setState({
                isRegistrationFeePaid: receiptInfo?.isRegistrationFeePaid || false
            })
        }
        else {
            // Handle two cases:
            // 1. receiptInfo from payment verification (flat structure with receiptNo at root)
            // 2. receiptInfo from feePaidInfo (nested structure with registration.receiptNo)

            const stageData = receiptInfo?.registration || receiptInfo;

            // Extract date - handle both ISO string and MongoDB $date object
            let receiptDate = stageData?.date || receiptInfo?.date;
            if (receiptDate && receiptDate.$date) {
                receiptDate = receiptDate.$date; // Extract from MongoDB format
            }

            let receiptData = {
                receiptName: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.label || 'Registration Fee',
                receiptNo: stageData?.receiptNo || receiptInfo?.receiptNo,
                receiptDate: receiptDate,
                studentName: stageData?.studentName || receiptInfo?.studentName || `${this.state.registration?.firstName || ''} ${this.state.registration?.lastName || ''}`.trim(),
                academicYear: stageData?.academicYearCode || receiptInfo?.academicYearCode || this.state.registration?.academicSession,
                className: stageData?.gradeName || receiptInfo?.gradeName || this.state.registration?.gradeName,
                paymentMode: stageData?.paymentMode || receiptInfo?.paymentMode || 'Online',
                // CRITICAL: Use transactionId (actual payment gateway ID), NOT orderId
                transactionId: stageData?.transactionId || stageData?.transctionId || receiptInfo?.transactionId || this.state.transctionId,

                feePaidDetails: [
                    {
                        feeType: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.feeName || 'Registration Fee',
                        amountPaying: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0),
                        fineAmtPaying: 0,
                        gstPaidNow: 0
                    }
                ],
                amountPaid: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0)
            }

            console.log('📄 Registration Receipt Data:', {
                stageData: stageData,
                transactionId: receiptData.transactionId,
                amountPaid: receiptData.amountPaid,
                orderId: stageData?.orderId,
                source: receiptInfo?.registration ? 'AdmissionFee document (nested)' : 'Payment verification (flat)'
            });

            this.setState({
                isShowReceipt: true,
                receiptInfo: receiptData,
                isRegistrationFeePaid: receiptInfo?.isRegistrationFeePaid || false,
                isPaymentJustCompleted: false // Reset the flag after showing receipt
            })
        }
        if (!this.state.isShowPayFeeButton) {
            this.setState({
                isRegistrationFeePaid: true
            })
        }
    }

    onCheckFeePaidInfo = async (isContinue) => {
        const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${this.state.registration?._id}`
        this.service.get(url, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    receiptInfo: res?.res?.data,
                }, () => this.handleShowReceipt(isContinue));
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })

    }
    handleParentDetailsChange = (value, field, index) => {
        const updatedParentDetails = this.state.parentDetails.map((parentDetail, idx) => {
            if (idx === index) {
                return { ...parentDetail, [field]: value };
            }
            return parentDetail;
        });

        this.setState({
            parentDetails: updatedParentDetails
        });
    };

    onClickParentDetailsPlusOrMinus = (bool, index) => {
        if (bool) {
            const { parentDetails } = this.state;
            const last = parentDetails[parentDetails.length - 1];
            if (!last || !last.relation || !last.name || !last.occupation || !last.qualification || !last.mobilenumber || !last.mailid) {
                return this.toast.show({
                    severity: 'error',
                    summary: 'Fill all the fields before adding new details',
                    life: 3000
                });
            }
            if (last.mobilenumber.length !== 10) return this.toast.show({
                severity: 'error',
                summary: 'Invalid Mobile Number',
                life: 3000
            });
            this.setState((prevState) => ({
                parentDetails: [
                    ...prevState.parentDetails,
                    { name: "", relation: "", occupation: "", qualification: "", mobilenumber: "", mailid: "" }
                ]
            }));
        }
        else if (bool === false) {
            const { parentDetails } = this.state
            const newArr = [...parentDetails]
            newArr.splice(index, 1)
            this.setState({ parentDetails: newArr })
        }
    }

    // ////////////PG SDK or Script loading////////
    loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // loadCashfreeSDK = () => {
    // }

    /**
     * Handle NTT Data payment initiation for registration
     */
    handleNTTDataPayment = () => {
        const { payFeeFormData, registration, feePayInfo } = this.state;

        const paymentData = {
            amount: this.state.partialPayment
                ? payFeeFormData?.amountPaying
                : (feePayInfo?.amount || payFeeFormData?.dueAmount),
            studentId: registration?._id,
            installmentId: payFeeFormData?.installmentId,
            feeFor: 'Admissions',
            feeType: 'Registration',
            studentName: registration?.firstName && registration?.lastName
                ? `${registration.firstName} ${registration.lastName}`.trim()
                : registration?.firstName || 'Student',
            studentEmail: registration?.emailId || registration?.parentEmailId || 'student@classet.com',
            studentPhone: registration?.parentContact || registration?.contactNo || '9999999999',
            branchId: registration?.branch,
            boardId: registration?.board,
            classId: registration?.grade,
            sectionId: registration?.section,
            orgId: localStorage.getItem('orgId'),
            referenceNo: registration?.referenceNo

        };

        console.log('Initiating NTT Data payment for registration with data:', paymentData);

        // Save registration state to sessionStorage before payment redirect
        const registrationStateToSave = {
            registration: registration,
            feePayInfo: feePayInfo,
            parents: this.state.parents,
            siblings: this.state.siblings,
            boards: this.state.boards,
            classes: this.state.classes,
            cityOrDist: this.state.cityOrDist,
            branchId: this.state.branchId,
            boardId: this.state.boardId,
            classId: this.state.classId,
            timestamp: Date.now()
        };

        console.log('💾 Saving registration state before payment:', {
            board: registration?.board,
            grade: registration?.grade,
            branchId: this.state.branchId,
            boardId: this.state.boardId,
            classId: this.state.classId,
            boardsCount: this.state.boards?.length,
            classesCount: this.state.classes?.length
        });

        sessionStorage.setItem('pendingRegistrationPayment', JSON.stringify(registrationStateToSave));
        sessionStorage.setItem('registrationAdmissionId', registration?._id);
        sessionStorage.setItem('registrationReferenceNo', registration?.referenceNo);

        this.setState({
            showNTTPayment: true,
            nttPaymentData: paymentData
        });
    };

    /**
     * Handle successful NTT payment for registration
     */
    onNTTPaymentSuccess = (paymentResult) => {
        console.log('NTT Payment successful for registration:', paymentResult);

        this.setState({
            transctionId: paymentResult.transactionId || paymentResult.payment_id,
            showNTTPayment: false,
            nttPaymentData: null
        }, () => {
            this.OnPayFee();
        });
    };

    /**
     * Handle NTT payment error for registration
     */
    onNTTPaymentError = (error) => {
        console.error('NTT Payment error for registration:', error);

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'error',
                summary: 'Payment Error',
                detail: error.message || 'Payment failed. Please try again.',
                life: 5000
            });
        }
    };

    /**
     * Handle NTT payment cancellation for registration
     */
    onNTTPaymentCancel = () => {
        console.log('NTT Payment cancelled for registration');

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'warn',
                summary: 'Payment Cancelled',
                detail: 'Payment was cancelled by user',
                life: 3000
            });
        }
    };

    /**
     * Handle payment redirect after gateway returns (for Registration)
     */
    handlePaymentRedirect = async (status, txnId, atomTxnId, referenceNo) => {
        console.log('Registration payment redirect detected:', { status, txnId, atomTxnId, referenceNo });

        // Restore registration state from sessionStorage
        const savedState = sessionStorage.getItem('pendingRegistrationPayment');

        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                const savedAdmissionId = sessionStorage.getItem('registrationAdmissionId');
                const savedReferenceNo = sessionStorage.getItem('registrationReferenceNo');

                // Check if saved state is not too old (30 minutes)
                if (Date.now() - parsedState.timestamp < 30 * 60 * 1000) {

                    if (status === 'success') {
                        // Payment successful
                        this.setState({
                            isLoading: true
                        });

                        // Verify payment status from backend
                        try {
                            const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                            const verifyResponse = await this.service.post(verifyUrl, {
                                txnId: txnId, // merchTxnId (order_id) - guaranteed to exist
                                atomTxnId: atomTxnId, // May not exist yet if callback hasn't arrived
                                admissionId: savedAdmissionId,
                                referenceNo: savedReferenceNo || referenceNo
                            }, true);

                            if (verifyResponse?.res?.status) {
                                // Payment verified successfully
                                const paymentData = verifyResponse.res.data;

                                console.log('📥 Restoring registration state after payment:', {
                                    board: parsedState.registration?.board,
                                    grade: parsedState.registration?.grade,
                                    branchId: parsedState.branchId,
                                    boardId: parsedState.boardId,
                                    classId: parsedState.classId,
                                    boardsCount: parsedState.boards?.length,
                                    classesCount: parsedState.classes?.length
                                });

                                // Restore registration state with ALL saved data
                                this.setState({
                                    registration: {
                                        ...parsedState.registration,
                                        registrationFeePaid: true
                                    },
                                    parents: parsedState.parents || [],
                                    siblings: parsedState.siblings || [],
                                    boards: parsedState.boards || this.state.boards,
                                    classes: parsedState.classes || this.state.classes,
                                    cityOrDist: parsedState.cityOrDist || this.state.cityOrDist,
                                    branchId: parsedState.branchId || this.state.branchId,
                                    boardId: parsedState.boardId || this.state.boardId,
                                    classId: parsedState.classId || this.state.classId,
                                    isRegistrationFeePaid: true,
                                    isLoading: false,
                                    receiptInfo: paymentData.receipt || null,
                                    isPaymentJustCompleted: true
                                }, () => {
                                    console.log('✅ State restored. Current values:', {
                                        registrationBoard: this.state.registration?.board,
                                        registrationGrade: this.state.registration?.grade,
                                        boardsCount: this.state.boards?.length,
                                        classesCount: this.state.classes?.length
                                    });

                                    // DON'T call onChangeBranch/onChangeBoard as they clear the selected values
                                    // The boards and classes arrays are already restored from savedState
                                    // Just set the registration.board and registration.grade values
                                    if (parsedState.registration?.board || parsedState.boardId) {
                                        this.setState(prevState => ({
                                            registration: {
                                                ...prevState.registration,
                                                board: parsedState.registration?.board || parsedState.boardId,
                                                grade: parsedState.registration?.grade || parsedState.classId
                                            }
                                        }));
                                    }

                                    // Format and show receipt using handleShowReceipt
                                    if (paymentData.receipt) {
                                        this.handleShowReceipt(true);
                                    }
                                });

                                // Show success message with confirmation
                                this.toast.show({
                                    severity: 'success',
                                    summary: '✅ Payment Successful',
                                    detail: `Registration fee paid successfully! Transaction ID: ${txnId}`,
                                    life: 8000,
                                    sticky: false
                                });

                                // Clear session storage
                                sessionStorage.removeItem('pendingRegistrationPayment');
                                sessionStorage.removeItem('registrationAdmissionId');
                                sessionStorage.removeItem('registrationReferenceNo');

                                // Clean URL
                                window.history.replaceState({}, document.title, '/addRegistration');
                            } else {
                                throw new Error(verifyResponse?.res?.message || 'Payment verification failed');
                            }
                        } catch (error) {
                            console.error('Payment verification error:', error);

                            // Restore form silently - verification may fail temporarily while callback is processing
                            this.setState({
                                registration: parsedState.registration,
                                parents: parsedState.parents || [],
                                siblings: parsedState.siblings || [],
                                boards: parsedState.boards || this.state.boards,
                                classes: parsedState.classes || this.state.classes,
                                cityOrDist: parsedState.cityOrDist || this.state.cityOrDist,
                                branchId: parsedState.branchId,
                                boardId: parsedState.boardId,
                                classId: parsedState.classId,
                                isLoading: false
                            });
                            // Don't call onChangeBranch/onChangeBoard - they clear selected values

                            // Clear session storage and URL
                            sessionStorage.removeItem('pendingRegistrationPayment');
                            sessionStorage.removeItem('registrationAdmissionId');
                            sessionStorage.removeItem('registrationReferenceNo');
                            window.history.replaceState({}, document.title, '/addRegistration');
                        }
                    } else if (status === 'failure') {
                        // Payment failed
                        this.setState({
                            registration: parsedState.registration,
                            parents: parsedState.parents || [],
                            siblings: parsedState.siblings || [],
                            boards: parsedState.boards || this.state.boards,
                            classes: parsedState.classes || this.state.classes,
                            cityOrDist: parsedState.cityOrDist || this.state.cityOrDist,
                            branchId: parsedState.branchId,
                            boardId: parsedState.boardId,
                            classId: parsedState.classId,
                            isLoading: false
                        });
                        // Don't call onChangeBranch/onChangeBoard - they clear selected values

                        this.toast.show({
                            severity: 'error',
                            summary: '❌ Payment Failed',
                            detail: 'Payment was not completed. Please try again.',
                            life: 5000
                        });

                        // Clean URL
                        window.history.replaceState({}, document.title, '/addRegistration');
                    } else if (status === 'cancelled') {
                        // Payment cancelled
                        this.setState({
                            registration: parsedState.registration,
                            parents: parsedState.parents || [],
                            siblings: parsedState.siblings || [],
                            boards: parsedState.boards || this.state.boards,
                            classes: parsedState.classes || this.state.classes,
                            cityOrDist: parsedState.cityOrDist || this.state.cityOrDist,
                            branchId: parsedState.branchId,
                            boardId: parsedState.boardId,
                            classId: parsedState.classId,
                            isLoading: false
                        });
                        // Don't call onChangeBranch/onChangeBoard - they clear selected values

                        this.toast.show({
                            severity: 'warn',
                            summary: 'Payment Cancelled',
                            detail: 'You cancelled the payment. You can retry payment anytime.',
                            life: 5000
                        });

                        // Clean URL
                        window.history.replaceState({}, document.title, '/addRegistration');
                    }
                } else {
                    // Session expired
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Session Expired',
                        detail: 'Payment session expired. Please start again.',
                        life: 5000
                    });
                    sessionStorage.removeItem('pendingRegistrationPayment');
                    sessionStorage.removeItem('registrationAdmissionId');
                    sessionStorage.removeItem('registrationReferenceNo');
                }
            } catch (error) {
                console.error('Error restoring registration state:', error);
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to restore registration data',
                    life: 5000
                });
            }
        } else {
            // No saved state - might be a direct link or manual refresh
            if (status === 'success' && referenceNo) {
                this.toast.show({
                    severity: 'info',
                    summary: 'Payment Completed',
                    detail: 'Loading your registration details...',
                    life: 3000
                });

                // Try to verify payment and load registration by referenceNo
                try {
                    const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                    const verifyResponse = await this.service.post(verifyUrl, {
                        txnId: txnId,
                        atomTxnId: atomTxnId,
                        referenceNo: referenceNo
                    }, true);

                    if (verifyResponse?.res?.status && verifyResponse.res.data?.referenceNo) {
                        // Load admission by referenceNo
                        const admissionId = sessionStorage.getItem('registrationAdmissionId') || localStorage.getItem('applicationId');
                        if (admissionId) {
                            await this.getAdmissionInfo(admissionId);

                            this.toast.show({
                                severity: 'success',
                                summary: '✅ Payment Confirmed',
                                detail: `Payment successful! Transaction ID: ${verifyResponse.res.data.transactionId}`,
                                life: 5000
                            });

                            // Clean URL
                            window.history.replaceState({}, document.title, '/addRegistration');
                        }
                    }
                } catch (error) {
                    console.error('Error loading registration after payment:', error);
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Payment Completed',
                        detail: 'Payment was successful but could not load registration. Please refresh the page.',
                        life: 5000
                    });
                }
            }
        }
    };



    handlePayment = async () => {
        let payType = this.state.payFeeFormData?.paymentType;
        let a = this.state.partialPayment ? this.state.payFeeFormData?.amountPaying : this.state.payFeeFormData?.dueAmount
        // let PGtype = 'cashfree'; // Default payment gateway type, can be changed based on user selection
        let PGtype = process.env.REACT_APP_DEFAULT_PAYMENT_GATEWAY || 'ntt_data';


        if (payType) {

            if (
                payType === '74b95cc8-9736-44a0-b2df-325595783c3b' ||
                payType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ||
                payType === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" ||
                payType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                payType === "274a4416-2454-4f3a-b741-89c67361ae1f"
            ) {
                this.OnPayFee()
            } else if (
                payType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
                payType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
            ) {
                switch (PGtype) {
                    case 'ntt_data': {
                        console.log('🔄 Initiating NTT Data payment for registration...');
                        this.handleNTTDataPayment();
                        break;
                    }
                    case 'razorpay': {
                        const res = await this.loadRazorpayScript();
                        if (!res) {
                            alert("Failed to load Razorpay SDK. Check your internet connection.");
                            return;
                        }
                        let url = `${baseUrlAdmin}/create-order`;
                        let vurl = `${baseUrlAdmin}/verify-payment`;

                        let payload = {
                            amount: this.state.partialPayment ? this.state.payFeeFormData?.amountPaying * 100 : this.state.payFeeFormData?.dueAmount * 100,
                            currency: "INR"
                        }
                        // Get order details from your backend
                        const { data: order } = await Axios.post(url, payload);

                        const options = {
                            key: "rzp_test_rJgczs9D0fmDjk", // Replace with your Razorpay key
                            amount: order.amount,
                            currency: order.currency,
                            name: "Classet",
                            description: "Purchase Description",
                            image: `https://${profilesBucket}.s3.${awsRegion}.amazonaws.com/uploads/17358829538761712311939159IMG-20231127-WA0017%20-%20Copy.jpg`,
                            order_id: order.id,
                            handler: async (response) => {
                                const result = await Axios.post(vurl, {
                                    order_id: order.id,
                                    razorpay_payment_id: response.razorpay_payment_id,
                                    razorpay_signature: response.razorpay_signature,
                                });
                                this.setState({
                                    transctionId: response.razorpay_payment_id
                                }, () => {
                                    this.OnPayFee();
                                })
                            },

                            prefill: {
                                name: "Monangi Kiran",
                                email: "kiranm@classet.in",
                                contact: "7799279701",
                            },
                            theme: {
                                color: "#3399cc",
                            },
                        };

                        const paymentObject = new window.Razorpay(options);
                        console.log("RAZOR", paymentObject)
                        paymentObject.open();
                    }; break;
                    case 'cashfree': {
                        let parentContactNumer;
                        if (this.state.searchLevel === 2) {
                            parentContactNumer = this.state?.dropdownsData?.parentContactNumber[0];
                        }

                        const url = `${baseUrlAdmin}/cashfree/create-order`;
                        const payload = {
                            orgId: localStorage.getItem('orgId'),
                            academicYear: localStorage.getItem('userAcademicYear'),
                            platform: 'web',

                            order_amount: this.state.partialPayment
                                ? this.state.payFeeFormData?.amountPaying
                                : this.state.feePayInfo?.amount,
                            order_currency: "INR",
                            order_id: "order_" + uuidv4(), // Generate a unique order ID using uuid
                            customer_details: {
                                customer_name: this.state?.registration?.firstName && this.state?.registration?.lastName
                                    ? `${this.state.registration.firstName} ${this.state.registration.lastName}`.trim()
                                    : `${this.state?.registration?.firstName}`,
                                customer_id: this.state?.registration?._id,
                                customer_email: this.state?.registration?.parentEmailId || this.state?.registration?.emailId,
                                customer_phone: this.state?.registration?.parentContact || this.state?.registration?.contactNo,
                            },
                            order_meta: {
                                return_url: null,
                            },
                        };

                        this.setState({ isLoading: true });

                        // Try asymmetric encryption first, fallback to symmetric, then unencrypted
                        const encryptPayload = async (payload) => {
                            try {
                                // Use only asymmetric (hybrid) encryption for strong security
                                console.log('🔐 Attempting hybrid encryption for Cashfree order creation...');
                                const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                if (hybridEncrypted.hybridEncrypted) {
                                    console.log('✅ Hybrid encryption successful for order creation');
                                    return hybridEncrypted;
                                }

                                // If encryption fails, throw error instead of sending unencrypted data
                                throw new Error('Hybrid encryption failed');

                            } catch (error) {
                                console.error('❌ Payment encryption failed:', error);
                                throw new Error('Payment encryption failed. Please try again.');
                            }
                        };

                        encryptPayload(payload)
                            .then((encryptedPayload) => {
                                return this.service.post(url, encryptedPayload, true);
                            })
                            .then(async (response) => {
                                this.setState({ isLoading: false });

                                console.log('🔍 Raw Cashfree order creation response:', response);

                                // Decrypt the response if it's encrypted
                                let decryptedResponse = response;

                                // Check if response needs decryption
                                if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                    try {
                                        console.log('🔓 Decrypting Cashfree order creation response...');
                                        console.log('🔍 Response structure before decryption:', {
                                            hasRes: !!response.res,
                                            encrypted: response.res?.encrypted,
                                            hybridEncrypted: response.res?.hybridEncrypted,
                                            keys: Object.keys(response.res || {})
                                        });

                                        // Decrypt using asymmetric encryption utils
                                        const decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                        console.log('✅ Order creation response decrypted successfully');
                                        console.log('🔍 Decrypted data structure:', {
                                            hasStatus: !!decryptedData.status,
                                            hasData: !!decryptedData.data,
                                            dataKeys: Object.keys(decryptedData.data || {}),
                                            hasPaymentSessionId: !!decryptedData.data?.payment_session_id
                                        });

                                        decryptedResponse = {
                                            ...response,
                                            res: decryptedData
                                        };

                                        // Also create direct data access for backward compatibility
                                        decryptedResponse.data = decryptedData.data;
                                        decryptedResponse.status = decryptedData.status;

                                    } catch (decryptError) {
                                        console.error('❌ Error decrypting order creation response:', decryptError);
                                        console.warn('⚠️ Using original response due to decryption error');
                                        // Continue with original response as fallback
                                    }
                                } else {
                                    console.log('✅ Response is not encrypted, using as-is');
                                    // For unencrypted responses, ensure proper structure
                                    if (response.res) {
                                        decryptedResponse.data = response.res.data;
                                        decryptedResponse.status = response.res.status;
                                    }
                                }

                                console.log('🔍 Final decryptedResponse structure:', {
                                    hasStatus: !!decryptedResponse.status,
                                    hasData: !!decryptedResponse.data,
                                    hasResStatus: !!decryptedResponse.res?.status,
                                    hasResData: !!decryptedResponse.res?.data,
                                    dataKeys: Object.keys(decryptedResponse.data || {}),
                                    resDataKeys: Object.keys(decryptedResponse.res?.data || {})
                                });

                                // Check for payment_session_id in correct response structure
                                let paymentSessionId = null;
                                let foundInLocation = '';

                                // Primary locations - check decrypted response first
                                if (decryptedResponse.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.data.payment_session_id';
                                } else if (decryptedResponse.res?.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.res.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.res.data.payment_session_id';
                                } else if (decryptedResponse.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.data.paymentSessionId';
                                } else if (decryptedResponse.res?.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.res.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.res.data.paymentSessionId';
                                }

                                console.log('🔍 Payment session ID search result:', {
                                    paymentSessionId,
                                    foundInLocation,
                                    searchedLocations: [
                                        'decryptedResponse.data.payment_session_id',
                                        'decryptedResponse.res.data.payment_session_id',
                                        'decryptedResponse.data.paymentSessionId',
                                        'decryptedResponse.res.data.paymentSessionId'
                                    ]
                                });

                                if (decryptedResponse.status && paymentSessionId) {
                                    console.log('✅ Payment session ID found:', paymentSessionId);

                                    //TO CREATE ORDER -> from order, paymentSessionId generated -> payments gets completed.
                                    // Open Cashfree checkout modal
                                    const checkoutOptions = {
                                        paymentSessionId: paymentSessionId,
                                        redirectTarget: "_modal",
                                    };
                                    const initializeCashfree = async () => {
                                        const { load } = await import('@cashfreepayments/cashfree-js');
                                        // const cashfree = await load({ mode: "sandbox" }); // Use "production" for live environment
                                        const cashfreeMode = process.env.REACT_APP_CASHFREE_MODE;
                                        const cashfree = await load({ mode: cashfreeMode });

                                        cashfree.checkout(checkoutOptions).then((result) => {
                                            if (result.error) {
                                                console.error("Payment error:", result.error);
                                            } else if (result.paymentDetails) {
                                                sendPaymentSessionDetails()
                                            }
                                        });
                                    };
                                    initializeCashfree();

                                    // Send and Store 
                                    const sendPaymentSessionDetails = async () => {
                                        // const isMobile = /Mobi|Android/i.test(navigator.userAgent); // Check if the user is on a mobile device
                                        const isDoneThrough = "Web-Admin"
                                        const loggedInUser = localStorage.getItem('username'); // Replace 'username' with the key used to store user info
                                        // console.log("**********Payment Details:*****************", paymentDetails);

                                        try {
                                            // Prepare the verify-and-collect payload
                                            const verifyCollectPayload = {
                                                platform: 'web',

                                                // Order and payment details
                                                orderId: payload.order_id,
                                                paymentSessionId: paymentSessionId,
                                                paymentDetails: 'payment finished',

                                                // Organization and academic details
                                                academicYear: localStorage.getItem('userAcademicYear'),
                                                orgId: localStorage.getItem('orgId'),
                                                academicSession: localStorage.getItem('userAcademicYear'),
                                                academicYearCode: this.state.registration?.enquiry?.academicYearCode,
                                                admissionCategoryName: this.state.registration?.enquiry?.admissionCategoryName,

                                                // Student details (using registration state instead of application)
                                                studentName: `${this.state?.registration?.firstName} ${this.state?.registration?.lastName}`,
                                                applicationNo: this.state?.registration?.applicationId,
                                                admissionId: this.state?.registration?._id,
                                                gradeName: this.state.registration?.gradeName,

                                                // Fee details for Registration stage
                                                stage: 'Registration',
                                                paymentMode: this.state.paymentModes?.find((el) => el.value == this.state.payFeeFormData?.paymentType)?.label || 'Online Payment',
                                                paymentType: this.state.payFeeFormData?.paymentType || '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54',
                                                feeTypeName: this.state.feePayInfo?.feeName,
                                                FeeTypeName: this.state.feePayInfo?.feeName, // Ensure both versions are included
                                                feeAmount: Number(this.state.feePayInfo?.amount),

                                                // Contact information (using registration data)
                                                branchId: this.state?.registration?.branch,
                                                boardId: this.state?.registration?.board,
                                                classId: this.state?.registration?.grade,
                                                sectionId: this.state?.registration?.sectionId,

                                                studentId: this.state?.registration?._id,
                                                enrollmentNo: 'NA', // Not applicable for registration stage
                                                parentContactNumber: this.state?.registration?.parentContact || this.state?.registration?.contactNo,

                                                // Metadata
                                                isDoneThrough: isDoneThrough,
                                                loggedInUser: loggedInUser,

                                                // Optional remarks
                                                remarks: this.state.payFeeFormData?.remarks || ''
                                            };

                                            // Encrypt verify-and-collect payload with asymmetric encryption only
                                            const encryptVerifyPayload = async (payload) => {
                                                try {
                                                    // Use only asymmetric (hybrid) encryption for strong security
                                                    console.log('🔐 Attempting hybrid encryption for payment verification...');
                                                    const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                                    if (hybridEncrypted.hybridEncrypted) {
                                                        console.log('✅ Hybrid encryption successful for verify-and-collect');
                                                        return hybridEncrypted;
                                                    }

                                                    // If encryption fails, throw error instead of sending unencrypted data
                                                    throw new Error('Hybrid encryption failed for verify-and-collect');

                                                } catch (error) {
                                                    console.error('❌ Payment verification encryption failed:', error);
                                                    throw new Error('Payment verification encryption failed. Please try again.');
                                                }
                                            };

                                            const encryptedVerifyPayload = await encryptVerifyPayload(verifyCollectPayload);
                                            const response = await this.service.post(`${baseUrlAdmin}/cashfree/verifyAndCollectAdmissionFee`, encryptedVerifyPayload, true);

                                            // Decrypt the response if it's encrypted (asymmetric only)
                                            let decryptedVerifyResponse = response;

                                            if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                                try {
                                                    console.log('🔓 Decrypting verify-and-collect response with asymmetric encryption...');

                                                    // Use only asymmetric decryption for strong security
                                                    let decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                                    decryptedVerifyResponse = {
                                                        ...response,
                                                        res: decryptedData
                                                    };

                                                    console.log('✅ Verify-and-collect response decrypted successfully with RSA + AES');
                                                } catch (decryptError) {
                                                    console.error('❌ Error decrypting verify-and-collect response:', decryptError);
                                                    // Continue with original response as fallback
                                                    console.warn('⚠️ Using original response due to decryption error');
                                                }
                                            }

                                            if (decryptedVerifyResponse?.res?.res?.data) {
                                                // Payment successful - handle receipt generation
                                                console.log(decryptedVerifyResponse?.res)
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.transactionId);
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.res?.transactionId);

                                                const receiptData = decryptedVerifyResponse.res.res.data;
                                                const paymentDetails = decryptedVerifyResponse.res.res.paymentDetails;
                                                console.log("Receipt Data:", receiptData);

                                                // Attach transactionId from decryptedVerifyResponse?.res to receiptData
                                                if (decryptedVerifyResponse?.res?.res?.transactionId) {
                                                    receiptData.transactionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId;
                                                    receiptData.transctionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId; // Also set the misspelled version for compatibility
                                                }

                                                // Set transaction ID from Cashfree payment details or response
                                                const transactionId = decryptedVerifyResponse?.res?.res?.transactionId || paymentDetails?.cf_payment_id || 'N/A';

                                                // Set transaction ID from Cashfree payment details
                                                if (paymentDetails) {
                                                    this.setState({
                                                        // transctionId: 'fsadjfl',
                                                        transctionId: transactionId,
                                                    });
                                                }

                                                // Show success message
                                                this.toast.show({
                                                    severity: 'success',
                                                    summary: 'Payment Successful',
                                                    detail: 'Payment completed successfully. Receipt generated.',
                                                    life: 3000
                                                });

                                                // Set receipt data and show receipt dialog
                                                this.setState({
                                                    isEnableReceipt: true,
                                                    receiptData: receiptData,
                                                    openCreateFeeDialog: false,
                                                    isLoading: false,
                                                    isOpenPayFeeDailog: false, // Add this line to close the Pay Fee dialog

                                                    // Clear form data
                                                    payFeeFormData: {},
                                                    transactionDate: null,
                                                    chequeIssuedTo: '',
                                                    chequeNo: '',
                                                    chequeDate: new Date(),
                                                    bankName: '',
                                                    bankBranchName: '',
                                                    destinationBank: '',
                                                    transctionId: '',
                                                    approvalCode: '',
                                                    rrNumber: '',
                                                    userBankName: '',
                                                    cardNo: ''
                                                });

                                                // this.getTermBasedData();
                                                this.onCheckFeePaidInfo(true);

                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: response?.res?.errMessage || 'Failed to verify payment details - receipts',
                                                    life: 3000,
                                                });
                                            }

                                        } catch (error) {
                                            console.error("Error sending payment session details:", error);

                                            // Check if it's an encryption error
                                            if (error.message && error.message.includes('encrypt')) {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Encryption Error',
                                                    detail: 'Failed to encrypt payment verification data',
                                                    life: 3000,
                                                });
                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: 'An error occurred while sending payment session details',
                                                    life: 3000,
                                                });
                                            }
                                        }
                                    };

                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: response.errMessage || 'Failed to create order (or) Cashfree subMerchantId not found for the organization',
                                        life: 3000,
                                    });
                                }
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });

                                // Check if it's an encryption error
                                if (error.message && error.message.includes('encrypt')) {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Encryption Error',
                                        detail: 'Failed to encrypt request data',
                                        life: 3000,
                                    });
                                    console.error("Encryption error:", error);
                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'An error occurred while creating order',
                                        life: 3000,
                                    });
                                    console.error("Error in Cashfree order creation:", error);
                                }
                            });
                    }; break;
                }
            }
        } else {
            this.toast.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Fill Payment Type And Amount', life: 3000 });
        }
    };

    OnPayFee = () => {
        const { payFeeFormData } = this.state
        const formStatus = isFormValid(createFields, this.payformFields.formValidations, trimObj(payFeeFormData));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                payFormValidations: formStatus.formValidations,
            });
            isCompleteFormValid = false;
        }
        let data = payFeeFormData
        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/admissions/payFee`
        let paymentMode = this.state.paymentModes.find(el => el.value == data?.paymentType)?.label
        data.paymentMode = paymentMode
        data.FeeTypeName = this.state.feePayInfo?.feeName
        data.feeAmount = Number(this.state.feePayInfo?.amount)
        data.transctionId = this.state?.transctionId

        if (data?.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' || data?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' || data?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' || data?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489') {
            if (!data?.transctionId) {
                this.setState({
                    isLoading: false,
                });
                this.toast.show({ severity: 'error', summary: 'Please enter transaction id.', detail: "Please enter transaction id.", life: 3000 });
                return
            }
        } else {
            data.transctionId = null
        }
        let payload = { ...data }
        if (this.state?.registration?._id) {
            payload.academicYearCode = this.state.registration?.enquiry?.academicYearCode
            payload.admissionCategoryName = this.state.registration?.enquiry?.admissionCategoryName
            payload.studentName = `${this.state?.registration?.firstName} ${this.state?.registration?.lastName}`
            payload.applicationNo = this.state?.registration?.applicationId
            payload.admissionId = this.state?.registration?._id
            payload.academicYear = this.state?.registration?.academicSession
            payload.gradeName = this.state.registration?.gradeName
            // Only set stage to Registration if student is not already enrolled
            if (this.state.registration?.stage !== "Confirmed") {
                payload.stage = "Registration"
            }
        }
        if (isCompleteFormValid) {
            this.service.post(url, payload, true).then(res => {
                if (res && res.status && res.res.status) {
                    if (res.res.data) {
                        this.setState({
                            isOpenPayFeeDailog: false,
                            isLoading: false,
                            payFeeFormData: {},
                            transctionId: null
                        }, () => { this.onCheckFeePaidInfo(true) });
                        this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false,
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res?.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res?.errMessage, life: 3000 });
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
            })
        } else {
            this.setState({
                isLoading: false,
            });
            this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'Some error occurred', life: 3000 });
        }

    }

    // ID validation and change methods
    validateIdDetails = (value, govtIdType) => {
        if (!value) return { isValid: false, errorMsg: 'ID Details is required' };

        switch (govtIdType) {
            case 'aadhaar':
                if (!/^\d{12}$/.test(value)) {
                    return { isValid: false, errorMsg: 'Aadhaar number must be 12 digits' };
                }
                break;
            case 'passport':
                if (!/^[A-Z]\d{7}$/.test(value)) {
                    return { isValid: false, errorMsg: 'Invalid passport format' };
                }
                break;
            default:
                if (value.length < 3) {
                    return { isValid: false, errorMsg: 'ID Details must be at least 3 characters' };
                }
        }
        return { isValid: true, errorMsg: '' };
    };

    onIdDetailsChange = (value) => {
        const { registration } = this.state;
        const validation = this.validateIdDetails(value, registration.govtIdType);

        this.setState(prevState => ({
            registration: {
                ...prevState.registration,
                idDetails: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    idDetails: validation
                }
            }
        }));
    };

    onGovtIdTypeChange = (value) => {
        const { registration } = this.state;

        this.setState(prevState => ({
            registration: {
                ...prevState.registration,
                govtIdType: value,
                idDetails: ''
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    govtIdType: { isValid: true, errorMsg: '' },
                    idDetails: { isValid: true, errorMsg: '' }
                }
            }
        }));
    };

    // Email validation method
    onEmailChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName, optionalRequired) => {
        let data = JSON.parse(JSON.stringify(formData));
        data[fieldName] = value;
        let fieldInfo = formFields.filter((f) => f.FieldName == fieldName);
        fieldInfo = fieldInfo[0];

        if (value != '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = true;
        }
        if (value == '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = false;
        }

        if (formValidations.fields[fieldName].isRequired) {
            if (value === '' || value === null || value === undefined) {
                formValidations.fields[fieldName].isValid = false;
                formValidations.fields[fieldName].errorMsg = `${fieldInfo.Label} is required`;
            } else if (fieldName.includes('Email') || fieldName.includes('email')) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    formValidations.fields[fieldName].isValid = false;
                    formValidations.fields[fieldName].errorMsg = 'Please enter a valid email address';
                } else {
                    formValidations.fields[fieldName].isValid = true;
                    formValidations.fields[fieldName].errorMsg = '';
                }
            } else {
                formValidations.fields[fieldName].isValid = true;
                formValidations.fields[fieldName].errorMsg = '';
            }
        } else {
            formValidations.fields[fieldName].isValid = true;
            formValidations.fields[fieldName].errorMsg = '';
        }

        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    };

    // Photo upload success handler
    _onStudenPhotoSuccess = (fileName, data) => {
        this.addAttachment('studentPhoto', fileName, data);
    };

    // Payment gateway script loading methods
    loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    // File upload related methods
    _onProgress = (filesInfo) => {
        // Handle upload progress if needed
    };

    _afterFilesUploaded = (files) => {
        console.log('Files uploaded:', files);
    };

    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Upload Error', detail: errMsg, life: 3000 });
    };

    onToggleChange = async (e, field) => {
        let data = JSON.parse(JSON.stringify(this.state.registration));
        let formValidations = this.state.formValidations;
        data[field] = e.value;
        let fieldInfo = createRegistrationFields.filter((f) => f.FieldName == field)
        if (formValidations.fields[field].isRequired) {
            if (!data[field]) {
                formValidations.fields[field] = { ...formValidations.fields[field], isValid: false, errorMsg: `${fieldInfo[0].Label} is required.` }
                formValidations.isFormValid = false;
            } else {
                formValidations.fields[field] = { ...formValidations.fields[field], isValid: true, errorMsg: `` }
            }
        }
        this.setState(
            {
                registration: data,
                formValidations,
                selectedFeeStructure: {},
                feeStructure: []
            },
        );
        if (e.value) {
            await this.getTransportInfo();
            await this.getFeeStructures()
        }

    }

    openDailogPayAppFee = () => {
        // if (!this.state?.registration?.applicationId) {
        //     this.toast.show({ severity: 'warn', summary: 'Warning', detail: 'Application ID is required to pay registration fee', life: 3000 });
        //     return;
        // }
        let paymentMode = paymentModes.filter((e) => e.value !== '1c98862e-46dc-4454-a120-7d15e2e56e2f' && e.value !== '9d08ebab-2d3e-4a30-8460-4e4092fe30a1')
        this.setState({ isOpenPayFeeDailog: true, paymentModes: paymentMode })
    }

    onHandleNavigate = (isContinue, isNext) => {
        if (isContinue && isNext) {
            localStorage.setItem('applicationId', this.state.registration?._id)
            this.props.navigate('/confirm-enrollment')
        } else {
            !this.state.isEdit ? this.props.navigate('/admission-registration') : this.setState({ isEdit: false }, () => this.props.onHandleClose())
        }
    }

    onSubmitApplication = (isContinue, isNext) => {

        if (!this.state.isRegistrationFeePaid) {
            // this.toast.show({ severity: 'error', summary: 'Please Pay Registration Fee', detail: 'Please Pay Registration Fee', life: 3000 });
            return
        }

        // Validate transport required fields
        if (this.state.registration?.transportRequired && (!this.state.registration?.requestedStop || this.state.registration?.requestedStop?.trim() === "")) {
            this.toast.show({ severity: 'error', summary: 'Requested Stop Required', detail: 'Please enter the requested stop when transport is required', life: 3000 });
            return
        }

        if (this.state.registration?.transport && !this.state.selectedFeeStructure) {
            this.toast.show({ severity: 'error', summary: 'Please Select Fee Structure', detail: 'Please Select Fee Structure', life: 3000 });
            return
        }
        if (this.state.registration?.transport && this.state?.requestedStop == "") {
            this.toast.show({ severity: 'error', summary: 'Please Select Requested Stop', detail: 'Please Select Requested Stop', life: 3000 });
            return
        }
        const { registration } = this.state
        const newReg = { ...registration, parentDetails: this.state.parentDetails }
        console.log(newReg);
        // let registrationData = { ...registration }
        registration.siblings = this.state.siblings
        registration.prevAcademicDetails = this.state.prevAcademicDetails
        registration.studentPhoto = registration?.studentPhoto || registration?.application?.studentPhoto
        // registration.houseNum = registration?.houseNum || registration?.application?.houseNum;
        registration.pinCode = registration?.pinCode || registration?.application?.pinCode;
        // registration.streetOrVillage = registration?.streetOrVillage || registration?.application?.streetOrVillage;
        // registration.mandal = registration?.mandal || registration?.application?.mandal;
        registration.cityOrDist = registration?.cityOrDist || registration?.application?.cityOrDist;
        registration.state = registration?.state || registration?.application?.state;
        //  payload = applicationData;
        registration.applicationId = this.state.registration?.applicationId;

        registration.previousSchool = this.state.registration?.previousSchool;


        registration._id = this.state.registration?._id;
        registration.orgId = this.state.registration?.orgId;
        registration.academicSession = this.state.registration?.academicSession;

        registration.currentLocation = this.state.registration?.currentLocation;
        // Only set stage to Registration if student is not already enrolled
        if (this.state.registration?.stage !== "Confirmed") {
            registration.stage = 'Registration';
        }
        // registration.houseNum = this.state.registration?.houseNum;
        // registration.streetOrVillage = this.state.registration?.streetOrVillage;
        // registration.mandal = this.state.registration?.mandal;
        registration.pinCode = this.state.registration?.pinCode;
        registration.state = this.state.registration?.state;
        registration.cityOrDist = this.state.registration?.cityOrDist;


        registration.branchName = this.state.selectedbranchName;
        registration.boardName = this.state.selectedBoardName;
        registration.gradeName = this.state.selectedGradeName;
        // Assign names based on specific UUIDs (not old selected ones)
        registration.branchName = this.props.branchData?.find((branch) => branch.key === this.state.registration?.branch)?.name || '';
        registration.boardName = this.state.boards?.find((board) => board.boardId === this.state.registration?.board)?.boardName || '';
        registration.gradeName = this.state.classes?.find((grade) => grade.classId === this.state.registration?.grade)?.className || '';

        registration.board = this.state.registration?.board;
        registration.grade = this.state.registration?.grade;
        registration.studentPhoto = this.state.registration?.studentPhoto;

        // Map parentQualification and occupation to qualification and profession for each parent
        const { parents, siblings } = this.state;
        console.log('🔍 Parents data before mapping:', parents);

        registration.parents = parents.map(parent => ({
            ...parent,
            // Prioritize the fields we're setting in onParentChange
            qualification: parent.qualification || parent.parentQualification || '',
            profession: parent.profession || parent.occupation || '',
            parentQualification: parent.qualification || parent.parentQualification || '',
            occupation: parent.profession || parent.occupation || '',
        }));
        registration.siblings = siblings;

        console.log('🔍 Parents data after mapping:', registration.parents);

        // Also set parentQualification and occupation at root for first parent (for backward compatibility)
        if (registration.parents && registration.parents.length > 0) {
            registration.parentQualification = registration.parents[0].qualification || registration.parents[0].parentQualification || '';
            registration.occupation = registration.parents[0].profession || registration.parents[0].occupation || '';
        }

        let registrationData = { ...registration }




        const formStatus = isFormValid(createRegistrationFields, this.formFields.formValidations, trimObj(registration));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
            });
            isCompleteFormValid = false;
        }

        //dtest
        // isCompleteFormValid = true;

        // ...existing code...
        if (!registration?.nationality ||
            !registration?.academicSession ||
            !registration?.academicCategory ||
            !registration?.branch ||
            !registration?.board ||
            !registration?.grade ||
            !registration?.previousSchool ||
            !registration?.previousBoard ||
            !registration?.previousGrade ||
            !registration?.firstName ||
            !registration?.lastName ||
            !registration?.gender ||
            !registration?.dob ||
            //    !registration?.studentPhoto ||
            !registration?.govtIdType ||
            !registration?.idDetails ||
            !registration?.religion ||
            !registration?.motherTongue ||
            !registration?.caste ||
            !registration?.stdCountryCode ||
            !registration?.stdContactNo ||
            !registration?.stdEmailId ||
            !registration?.currentLocation ||
            !registration?.identificationMarks ||
            !registration?.parentType ||
            !registration?.parentName ||
            //    !registration?.qualification ||
            //    !registration?.profession ||
            !registration?.parentContact ||
            !registration?.parentEmailId ||
            !registration?.addressLine ||
            !registration?.pinCode ||
            !registration?.state ||
            !registration?.cityOrDist ||

            !registration?.contactNo ||
            !registration?.emailId
        ) {
            this.toast.show({ severity: 'error', summary: 'Please fill all mandatory fields', detail: 'Please fill all mandatory fields', life: 3000 });
            // isCompleteFormValid = false;
            return
        }
        // ...existing code...

        let slectedTransportInfo = []
        if (registration?.transport) {
            const { routesList } = this.state
            slectedTransportInfo = routesList?.filter(el => el.stopId === this.state?.requestedStop)
        }
        const academicSession = localStorage.getItem('userAcademicYear')
        if (isCompleteFormValid) {
            let payload = {
                registrationData: registrationData,
                // Only set stage to Registration if student is not already enrolled
                stage: this.state.registration?.stage === "Confirmed" ? "Confirmed" : "Registration",
                _id: registration?._id,
                board: registration?.board,
                academicSession: academicSession,
                grade: registration?.grade,
                applicationId: registration?.applicationId,
                identificationMarks: registration.identificationMarks,
                bloodGroup: registration.bloodGroup,
                motherTongue: registration.motherTongue,
                nationality: registration.nationality,
                religion: registration.religion,
                caste: registration.caste,
                parentDetails: this.state.parentDetails,

                // Include government ID details
                govtIdType: registration.govtIdType,
                idDetails: registration.idDetails,

                // Include parent data
                parents: registration.parents,
                parentQualification: registration.parentQualification,
                occupation: registration.occupation,

                // fatherName: registration.fatherName,
                // fatherOccupation: registration.fatherOccupation,
                // fatherQualification: registration.fatherQualification,
                // fatherMobileNum: registration.fatherMobileNum,
                // fatherEmailId: registration.fatherEmailId,
                // motherEmailId: registration.motherEmailId,
                // guardianEmailId: registration.guardianEmailId,
                // motherMobileNum: registration.motherMobileNum,
                // guardianMobileNum: registration.guardianMobileNum,
                // motherQualification: registration.motherQualification,
                // guardianQualification: registration.guardianQualification,
                // motherOccupation: registration.motherOccupation,
                // guardianOccupation: registration.guardianOccupation,
                // guardianName: registration.guardianName,
                // motherName: registration.motherName,
                // houseNum: registration.houseNum,
                pinCode: registration.pinCode,
                // streetOrVillage: registration.streetOrVillage,
                // mandal: registration.mandal,
                cityOrDist: registration.cityOrDist,
                state: registration.state,
                transport: registration.transport || false,
                siblings: registration.siblings,
                // prevAcademicDetails: registration.prevAcademicDetails,
                studentPhoto: registration.studentPhoto,
                requestedStop: this.state.requestedStop || "",
                transportInfo: slectedTransportInfo?.length && slectedTransportInfo[0],
                feeStructure: this.state.selectedFeeStructure

            }
            this.setState({
                isLoading: true
            });
            if (isNext) {
                payload.stage = "Enrollment"
            }

            // Use update endpoint if editing existing registration, otherwise use add
            const isEditing = registration?._id;
            const url = `${baseUrlAdmin}/admissions/add-registration`;

            this.service.post(url, payload, true).then(res => {
                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false,
                        createdId: res?.res?.data,
                    }, () => { this.onHandleNavigate(isContinue, isNext) });
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred Submitting application', detail: res.errMessage, life: 3000 });
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: "Error", detail: 'Some error occurred', life: 3000 });
                console.log(e);
            })

        } else {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'Some error occurred', life: 3000 });
        }

    }

    getFeeStructures = async () => {
        this.setState({
            isLoading: true
        });
        const { registration, } = this.state
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/fee-structure/transportfees?academicYear=${academicYear}&isNew=${true}`;
        this.service.get(url, true).then(res => {
            if (res && res.status && res.res.status) {
                if (res.res.data && res.res?.data?.length > 0) {
                    this.setState({
                        isLoading: false,
                        feeStructure: res.res.data || []
                    });
                } else {
                    this.setState(prevState => ({
                        isLoading: false,
                        registration: { ...prevState.registration, transport: false }
                    }));
                    this.toast.show({ severity: 'error', summary: 'No transport fee structures found.', detail: res.errMessage, life: 3000 });
                }
            } else {
                this.setState(prevState => ({
                    isLoading: false,
                    registration: { ...prevState.registration, transport: false }
                }));
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            console.log(e);
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });

        })
    }

    getTransportInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/admissions/transportInfo?academicYear=${academicYear}`;
        let payload = {}
        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                if (res.res.data && res.res?.data?.routesList?.length) {
                    this.setState({
                        isLoading: false,
                        routesList: res.res.data.routesList,
                    });
                }
            } else {
                this.setState(prevState => ({
                    isLoading: false,
                    registration: { ...prevState.registration, transport: false }
                }));
                this.toast.show({ severity: 'error', summary: 'Please create transport routes.', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState(prevState => ({
                isLoading: false,
                registration: { ...prevState.registration, transport: false }
            }));
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
            console.log(e);
        })
    }

    onSetClasses = () => {
        const { dob, registration, ageCriteriaInfo, admissionSettingsInfo, selectedClassesList } = this.state

        // Early return if selectedClassesList is not available
        if (!selectedClassesList || !Array.isArray(selectedClassesList)) {
            return;
        }

        if (admissionSettingsInfo?.ageCriteria) {
            let classesInfo
            if (dob && registration?.board) {
                // Check if age criteria data exists for the selected board
                if (!ageCriteriaInfo || !Array.isArray(ageCriteriaInfo) || ageCriteriaInfo.length === 0) {
                    // No age criteria configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList
                    });
                    return;
                }

                // Check if any grade has valid dates configured (not null/undefined)
                const hasValidDates = ageCriteriaInfo.some(cls =>
                    cls.bornBefore && cls.bornAfter &&
                    cls.bornBefore !== null && cls.bornAfter !== null
                );

                if (!hasValidDates) {
                    // Dates not configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList
                    });
                    return;
                }

                // Age criteria is configured with valid dates, filter based on DOB
                classesInfo = ageCriteriaInfo.filter(cls => {
                    // Skip grades without valid dates
                    if (!cls.bornBefore || !cls.bornAfter) return false;

                    const dateOfBirth = new Date(dob.toDateString());
                    const bornBeforeDate = new Date(new Date(cls.bornBefore).toDateString());
                    const bornAfterDate = new Date(new Date(cls.bornAfter).toDateString());

                    return dateOfBirth >= bornAfterDate && dateOfBirth <= bornBeforeDate;
                });
                const classIds = new Set(classesInfo.map(item => item.classId));


                const matchedClasses = selectedClassesList.filter(item => classIds.has(item.classId));
                if (!matchedClasses.length) {
                    // Age criteria is configured but DOB doesn't match any grade - show error
                    this.setState({
                        isLoading: false,
                        classes: [],
                        registration: {
                            ...this.state.registration,
                            grade: ''
                        }
                    });
                    this.toast?.show({ severity: 'error', summary: 'Age not eligible for any grades', detail: "Age not eligible for any grades", life: 3000 });
                } else {
                    // Check if currently selected grade is still in the matched classes
                    const isSelectedGradeValid = matchedClasses.some(cls => cls.classId === this.state.registration.grade);

                    this.setState({
                        classes: matchedClasses,
                        registration: {
                            ...this.state.registration,
                            grade: isSelectedGradeValid ? this.state.registration.grade : ''
                        }
                    })
                }
            } else if (!dob) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please select DOB', detail: "Please select DOB", life: 3000 });
            } else {
                this.setState({
                    classes: selectedClassesList
                })
            }

        } else {
            this.setState({
                classes: selectedClassesList
            })
        }
    }

    getAgeCriteriaInfo = async (branchId, boardId, finalClassesList) => {
        this.setState({
            isLoading: true
        });
        const { dob, registration, admissionSettingsInfo, ageCriteriaInfo } = this.state

        console.log('🔍 getAgeCriteriaInfo called with DOB:', dob, 'registration.dob:', registration?.dob);

        const academicYear = registration?.academicSession || localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/agecriteria?boardId=${boardId}&branchId=${branchId}&academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {

                this.setState({ ageCriteriaInfo: res?.res?.data, isLoading: false }, () => this.onSetClasses(finalClassesList));
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    }

    onEmailChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName, optionalRequired) => {
        let data = JSON.parse(JSON.stringify(formData));
        data[fieldName] = value;
        let fieldInfo = formFields.filter((f) => f.FieldName == fieldName);
        fieldInfo = fieldInfo[0];
        if (value != '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = true
        }
        if (value == '' && optionalRequired) {
            formValidations.fields[fieldName].isRequired = false
        }
        if (formValidations.fields[fieldName].isRequired) {
            if (data[fieldName] == '' || data[fieldName] == null) {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: false,
                    errorMsg: `${fieldInfo.RequiredMsg ? fieldInfo.RequiredMsg : fieldInfo.Label + ' is required'}`
                }
                formValidations.isFormValid = false;
            }
            // else if ((data[fieldName] != '' && data[fieldName] != null) && !isValidEmail(data[fieldName])) {
            //     formValidations.fields[fieldName] = {
            //         ...formValidations.fields[fieldName],
            //         isValid: false,
            //         errorMsg: `${fieldInfo.Label} is invalid.`
            //     }
            //     formValidations.isFormValid = false;
            // } 
            else {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: true,
                    errorMsg: ``
                }
            }
        } else {
            if (optionalRequired && value == '') {
                formValidations.fields[fieldName] = {
                    ...formValidations.fields[fieldName],
                    isValid: true,
                    errorMsg: ``
                }
            }
        }

        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    }

    onChangeClass = (classId) => {
        const { classes } = this.state
        let selectedClassId = classes.find(el => el.classId === classId)
        let groupId = selectedClassId?.groups[0]?.groupId
        let groupName = selectedClassId?.groups[0]?.groupName
        this.setState({
            groupId: groupId,
        })
    }


    render() {
        const { registration, formValidations, payFeeFormData, payFormValidations } = this.state;


        return (

            <>
                <div className=''>
                    <br />
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Academic Details</u>
                        </h1>
                    </div>

                    {/* Admission Year, Academic Category */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >

                        {/* {registration?.applicationId && */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Application ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    height={48}
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    // id="title"
                                    className='  add-vehicle-field-input w-full '
                                    value={registration.applicationId}
                                    onChange={(e) => onTextChange(e.target.value, 'applicationId', this, formFields, registration, formValidations, 'registration', 'formValidations')}
                                    placeholder="Application ID"
                                    disabled={true} />
                            </div>
                            {formValidations && !formValidations.fields['applicationId'].isValid && <p className="p-error text-lg">{formValidations.fields['applicationId'].errorMsg}</p>}
                        </div>
                        {/* } */}
                        {/* </div> */}

                        {/* Academic Year dropdown to use the same data source as AppTopbar */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Academic Year<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    height={48}
                                    className='text-xl add-vehicle-field-input w-full'
                                    // value={registration.academicYearCode || registration.enquiry?.academicYearCode || ''}
                                    value={
                                        (() => {
                                            const userAcademicYear = localStorage.getItem('userAcademicYear');
                                            const matchingSession = this.state.academicSession?.find(session => session.value === userAcademicYear);
                                            return matchingSession?.label || registration.academicYearCode || registration.enquiry?.academicYearCode || userAcademicYear || '';
                                        })()
                                    }
                                    placeholder='Academic Year'
                                    disabled={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicSession']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['academicSession']?.errorMsg}</p>
                            )}
                        </div>

                        {/* Admission Category dropdown */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Admission Category<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.academicCategory}
                                    options={this.state.academicCategory || []}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'academicCategory', this, formFields, registration, formValidations, 'registration', 'formValidations') }}
                                    placeholder='Admission Category'
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicCategory'].isValid && <p className="p-error text-lg">{formValidations.fields['academicCategory'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Branch board grade */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Branch<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='name'
                                    optionValue='key'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.branch}
                                    options={this.props.branchData}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'branch', this, formFields, registration, formValidations, 'registration', 'formValidations'); this.onChangeBranch(e.target.value) }}
                                    placeholder='Select Branch'
                                />
                            </div>
                            {formValidations && !formValidations.fields['branch'].isValid && <p className="p-error text-lg">{formValidations.fields['branch'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='boardName'
                                    optionValue='boardId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.board}
                                    options={this.state.boards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'board', this, formFields, registration, formValidations, 'registration', 'formValidations'); this.onChangeBoard(e.target.value) }}
                                    placeholder='Select Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields['board'].isValid && <p className="p-error text-lg">{formValidations.fields['board'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='className'
                                    optionValue='classId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.grade}
                                    options={this.state?.classes}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'grade', this, formFields, registration, formValidations, 'registration', 'formValidations'); this.onChangeClass(e.target.value) }}
                                    placeholder='Select Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['grade'].isValid && <p className="p-error text-lg">{formValidations.fields['grade'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Prev  Branch board grade */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous School<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className=' add-vehicle-field-input w-full '
                                    value={registration.previousSchool}
                                    onChange={(e) => onTextChange(e.target.value, 'previousSchool', this, formFields, registration, formValidations, 'registration', 'formValidations')}
                                    placeholder="Previous School" />
                            </div>
                            {formValidations && !formValidations.fields['previousSchool'].isValid && <p className="p-error text-lg">{formValidations.fields['previousSchool'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">

                            <p className='transport-fee-form-label'>Previous Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.previousBoard}
                                    options={this.state.previousBoards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'previousBoard', this, formFields, registration, formValidations, 'registration', 'formValidations') }}
                                    placeholder='Select Previous Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousBoard'].isValid && <p className="p-error text-lg">{formValidations.fields['previousBoard'].errorMsg}</p>}
                        </div>


                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.previousGrade}
                                    // options={this.state.classStudyingDrp}
                                    options={gradePriorityOptions}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'previousGrade', this, formFields, registration, formValidations, 'registration', 'formValidations');
                                    }}
                                    placeholder='Select Previous Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousGrade']?.isValid && <p className="p-error text-lg">{formValidations.fields['previousGrade']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Student | Personal Details */}
                    <br />
                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Personal Details</u>
                        </h1>
                    </div>
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student First Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={registration.firstName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'firstName', this, formFields, registration, formValidations, 'registration', 'formValidations');
                                        }
                                    }}
                                    placeholder="Student First Name" />
                            </div>
                            {formValidations && !formValidations.fields['firstName'].isValid && <p className="p-error text-lg">{formValidations.fields['firstName'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Middle Name</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={registration.middleName} // Corrected field
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'middleName', this, formFields, registration, formValidations, 'registration', 'formValidations'); // Corrected field
                                        }
                                    }}
                                    placeholder="Student Middle Name"
                                />
                            </div>
                            {formValidations && !formValidations.fields['middleName']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['middleName']?.errorMsg}</p> // Corrected field
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Last Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={registration.lastName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'lastName', this, formFields, registration, formValidations, 'registration', 'formValidations')
                                        }
                                    }}
                                    placeholder="Student Last Name" />
                            </div>
                            {formValidations && !formValidations.fields['lastName'].isValid && <p className="p-error text-lg">{formValidations.fields['lastName'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Gender, DOB, Upload photo */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Gender<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}

                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.gender}
                                    options={this.state.gender}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'gender', this, formFields, registration, formValidations, 'registration', 'formValidations') }}
                                    placeholder='Select Gender'
                                />
                            </div>
                            {formValidations && !formValidations.fields['gender'].isValid && <p className="p-error text-lg">{formValidations.fields['gender'].errorMsg}</p>}

                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Date of Birth<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetCalendar
                                    width={250}
                                    className='border-round-md add-vehicle-field-input text-xl w-full'
                                    calendarMode={'single'}
                                    value={registration.dob ? new Date(registration.dob) : null}
                                    onChange={(e) => {
                                        onTextChange(e.value, 'dob', this, formFields, registration, formValidations, 'registration', 'formValidations');
                                        this.setState({ dob: e.value }, () => {
                                            // Re-fetch age criteria if board and branch are selected
                                            if (this.state.registration?.board && this.state.registration?.branch) {
                                                this.getAgeCriteriaInfo(
                                                    this.state.registration.branch,
                                                    this.state.registration.board,
                                                    this.state.selectedClassesList
                                                );
                                            } else {
                                                this.onSetClasses();
                                            }
                                        });
                                    }}
                                    placeholder="DOB"
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Upload Photo
                            </p>
                            <div className="flex">
                                <FileUpload
                                    id={'student'}
                                    multiple={false}
                                    onProgress={this._onProgress}
                                    onSucess={this._onStudentPhotoSuccess} // Note: It's 'onSucess' not 'onSuccess' (matching registration.js)
                                    maxFileSize={5242880} // 5MB in bytes
                                    onError={this._onFilesUploadError} // Note: It's '_onFilsUploadError' not '_onFilesUploadError' (matching registration.js)
                                    accept={'images'} // Changed to 'images' to match registration.js
                                    title={'Upload Student Photo'}
                                    afterFilesUploaded={this._afterFilesUploaded}
                                    className="border-solid"
                                    disabled={this.state.isLoading}
                                >
                                    <ClassetInputText
                                        width={250}
                                        icon={<FileAttachmentIcon width={24} height={24} color={'black'} />}
                                        className="add-vehicle-field-input w-full"
                                        value={registration.studentPhoto?.fileName || ''}
                                        placeholder="Upload Photo"
                                        disabled={true}
                                    />
                                </FileUpload>
                            </div>
                            {formValidations && !formValidations.fields['studentPhoto']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['studentPhoto']?.errorMsg}</p>
                            )}
                        </div>
                    </div>

                    {/* Nationality, Govt Id, id details */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        {/* nationality */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Nationality<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='name'
                                    optionValue='code'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.nationality}
                                    options={this.state.countries}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'nationality', this, formFields, registration, formValidations, 'registration', 'formValidations') }}
                                    placeholder='Select Nationality'
                                />
                            </div>
                            {formValidations && !formValidations.fields['nationality']?.isValid && <p className="p-error text-lg">{formValidations.fields['nationality']?.errorMsg}</p>}
                        </div>


                        {/* Gov ID */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Govt ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.govtIdType}
                                    options={this.state.govtIdTypes}
                                    onChange={(e) => {
                                        this.onGovtIdTypeChange(e.target.value);
                                    }}
                                    placeholder='Select Govt ID'
                                />
                            </div>
                            {formValidations && !formValidations.fields['govtIdType']?.isValid && <p className="p-error text-lg">{formValidations.fields['govtIdType']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>ID Details<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter={registration.govtIdType === 'aadhaar' ? 'int' : null} // Only allow numbers for Aadhaar
                                    maxLength={registration.govtIdType === 'aadhaar' ? 12 : registration.govtIdType === 'passport' ? 8 : undefined}
                                    className='add-vehicle-field-input w-full'
                                    value={registration.idDetails}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // Apply specific filters based on govt ID type
                                        if (registration.govtIdType === 'aadhaar') {
                                            // Only allow digits for Aadhaar
                                            value = value.replace(/\D/g, '');
                                            if (value.length > 12) value = value.slice(0, 12);
                                        } else if (registration.govtIdType === 'passport') {
                                            // Only allow alphanumeric for Passport
                                            value = value.replace(/[^A-Za-z0-9]/g, '');
                                            if (value.length > 8) value = value.slice(0, 8);
                                            value = value.toUpperCase(); // Convert to uppercase for consistency
                                        }

                                        this.onIdDetailsChange(value);
                                    }}
                                    placeholder={
                                        registration.govtIdType === 'aadhaar' ? "Enter Aadhaar number"
                                            : registration.govtIdType === 'passport'
                                                ? "Enter Passport number"
                                                : "Enter ID Details"
                                    }
                                    disabled={!registration.govtIdType} // Disable if no govt ID type is selected
                                />
                            </div>
                            {formValidations && !formValidations.fields['idDetails']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['idDetails']?.errorMsg}</p>
                            )}
                            {/* Show format hint */}
                            {registration.govtIdType && (
                                <small className="p-text-secondary">
                                    {registration.govtIdType === 'aadhaar' && "Format: 12 digits (e.g., 123456789012)"}
                                    {registration.govtIdType === 'passport' && "Format: 8 alphanumeric characters (e.g., A1234567)"}
                                </small>
                            )}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Blood Group</p>
                            <div className="flex">
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    placeholder="Select Blood Group"
                                    className="add-vehicle-field-input"
                                    value={registration.bloodGroup}
                                    options={[
                                        { label: 'A+', value: 'A+' },
                                        { label: 'A-', value: 'A-' },
                                        { label: 'B+', value: 'B+' },
                                        { label: 'B-', value: 'B-' },
                                        { label: 'O+', value: 'O+' },
                                        { label: 'O-', value: 'O-' },
                                        { label: 'AB+', value: 'AB+' },
                                        { label: 'AB-', value: 'AB-' }
                                    ]}
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            registration: {
                                                ...prevState.registration,
                                                bloodGroup: e.value
                                            }
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Religion, Mother Tongue, Caste */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Religion<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.religion}
                                    options={this.state.religions}
                                    onChange={(e) => onDropDownChange(e.target.value, 'religion', this, formFields, registration, formValidations, 'registration', 'formValidations')}
                                    placeholder='Select Religion'
                                />
                            </div>
                            {formValidations && !formValidations.fields['religion']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['religion']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Mother Tongue<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={registration.motherTongue}
                                    // onChange={(e) => onTextChange(e.target.value, 'motherTongue', this, formFields, registration, formValidations, 'registration', 'formValidations')}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'motherTongue', this, formFields, registration, formValidations, 'registration', 'formValidations');
                                    }}
                                    placeholder="Enter Language"
                                />
                            </div>
                            {formValidations && !formValidations.fields['motherTongue']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['motherTongue']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Caste<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.caste}
                                    options={this.state.castes}
                                    onChange={(e) => onDropDownChange(e.target.value, 'caste', this, formFields, registration, formValidations, 'registration', 'formValidations')}
                                    placeholder='Select Caste'
                                />
                            </div>
                            {formValidations && !formValidations.fields['caste']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['caste']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >


                        {/* // The Country Code dropdown remains the same - it will now use the JSON data */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Country Code<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={registration.stdCountryCode}
                                    options={this.state.countryPhoneCodes} // This now uses JSON data
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'stdCountryCode', this, formFields, registration, formValidations, 'registration', 'formValidations');
                                    }}
                                    placeholder='Select Country Phone Code'
                                />
                            </div>
                            {formValidations && !formValidations.fields['stdCountryCode']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdCountryCode']?.errorMsg}</p>}
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Contact no<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter='int'
                                    maxLength={10}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={registration.stdContactNo}
                                    onChange={(e) => this.onContactNumberChange(e.target.value, 'stdContactNo')}
                                    placeholder="Contact No (10 digits)" />
                            </div>
                            {formValidations && !formValidations.fields['stdContactNo']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdContactNo']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Email ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={registration.stdEmailId}
                                    onChange={(e) => this.onEmailChangeWithValidation(e.target.value, 'stdEmailId')}
                                    placeholder="Email ID" />
                            </div>
                            {formValidations && !formValidations.fields['stdEmailId']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdEmailId']?.errorMsg}</p>}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Current Location<span className='ma-required'>*</span></p>
                            <div className="flex">
                                <ClassetInputText
                                    width={250}
                                    className="add-vehicle-field-input w-full"
                                    value={registration.currentLocation}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'currentLocation', this, formFields, registration, formValidations, 'registration', 'formValidations');
                                    }}
                                    placeholder="Enter Current Location"
                                />
                            </div>
                            {formValidations && !formValidations.fields['currentLocation']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['currentLocation']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2"> */}
                        <div className="">
                            <p className="transport-fee-form-label">Identification Marks<span className='ma-required'>*</span></p>
                            <div className="flex">
                                <ClassetTextArea
                                    width={680}

                                    placeholder="Enter Identification Marks"
                                    className="add-vehicle-field-input w-full"
                                    // style={{ width: '100%' }} // Ensure full width
                                    value={registration.identificationMarks}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'identificationMarks',
                                            this,
                                            formFields,
                                            registration,
                                            formValidations,
                                            'registration',
                                            'formValidations'
                                        )
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['identificationMarks']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['identificationMarks']?.errorMsg}</p>
                            )}
                        </div>

                    </div>

                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-1 ' style={{ color: 'black' }}>
                            <u>Parent Details</u>
                        </h1>
                    </div>
                    <br />

                    {/* // Update the Parent Details section in the render method */}


                    {this.state.parents.map((parent, index) => (
                        <div key={index} className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Relationship<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.parentType} // Changed from registration.parentType to parent.parentType
                                        options={this.state.parentTypes}
                                        onChange={(e) => { this.onParentChange(e.target.value, index, 'parentType') }}
                                        placeholder='Relationship'
                                    />
                                </div>
                                {index === 0 && formValidations && !formValidations.fields['parentType'].isValid && <p className="p-error text-lg">{formValidations.fields['parentType'].errorMsg}</p>}
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Parent Name<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.parentName} // Changed from registration.parentName to parent.parentName
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentName')}
                                        placeholder="Enter Parent Name"
                                    />
                                </div>
                                {index === 0 && formValidations && !formValidations.fields['parentName'].isValid && <p className="p-error text-lg">{formValidations.fields['parentName'].errorMsg}</p>}
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Qualification<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.qualification} // Changed from registration.qualification to parent.qualification
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'qualification')}
                                        placeholder="Enter Qualification"
                                    // keyfilter='alpha'

                                    />
                                </div>
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Profession<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.profession} // Changed from registration.profession to parent.profession
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'profession')}
                                        placeholder="Enter Profession"
                                    // keyfilter='alpha'

                                    />
                                </div>
                            </div>

                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Country Code<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.countryCode} // Changed from registration.countryCode to parent.countryCode
                                        options={this.state.countryPhoneCodes}
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'countryCode')}
                                        placeholder='Select Country Phone Code'
                                    />
                                </div>
                                {index === 0 && formValidations && !formValidations.fields['countryCode'].isValid && <p className="p-error text-lg">{formValidations.fields['countryCode'].errorMsg}</p>}
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Contact No.<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        keyfilter='int'
                                        maxLength={10}
                                        className=' add-vehicle-field-input w-full '
                                        value={parent.parentContact} // Changed from registration.parentContact to parent.parentContact
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentContact')}
                                        placeholder="Contact No. (10 digits)"
                                    />
                                </div>
                                {this.state.parentValidations[index]?.parentContact && !this.state.parentValidations[index]?.parentContact?.isValid ? (
                                    <p className="p-error text-lg">{this.state.parentValidations[index]?.parentContact?.errorMsg}</p>
                                ) : (index === 0 && formValidations && !formValidations.fields['parentContact'].isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['parentContact'].errorMsg}</p>
                                ))}
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Email ID<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='  add-vehicle-field-input w-full '
                                        value={parent.parentEmailId} // Changed from registration.parentEmailId to parent.parentEmailId
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentEmailId')}
                                        placeholder="Parent/Guardian Email ID"
                                    />
                                </div>
                                {this.state.parentValidations[index]?.parentEmailId && !this.state.parentValidations[index]?.parentEmailId?.isValid ? (
                                    <p className="p-error text-lg">{this.state.parentValidations[index]?.parentEmailId?.errorMsg}</p>
                                ) : (index === 0 && formValidations && !formValidations.fields['parentEmailId'].isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['parentEmailId'].errorMsg}</p>
                                ))}
                            </div>

                            <div className="col-span-1 flex align-items-center">
                                <Button icon="pi pi-plus" aria-label="Add Parent" onClick={() => this.addParent()} style={{ marginRight: '5px' }} />
                                {this.state.parents.length > 1 && (
                                    <Button icon="pi pi-minus" aria-label="Remove Parent" onClick={() => this.removeParent(index)} />
                                )}
                            </div>
                        </div>
                    ))}



                    {/* Remarks */}
                    <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2">
                        <div className="" >
                            <p className="transport-fee-form-label">Remarks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    placeholder='Remarks'
                                    className=""
                                    width={680}
                                    value={registration.remarks}
                                    onChange={(e) => onTextChange(e.target.value, 'remarks', this, formFields, registration, formValidations, 'registration', 'formValidations')}
                                />
                            </div>
                            {formValidations && !formValidations.fields['remarks'].isValid && <p className="p-error text-lg">{formValidations.fields['remarks'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* SIBLINGS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Siblings</u>
                        </h1>
                    </div>
                    <br />
                    <div className='p-grid ma-w100p mx-5 ma-p20 mb-5'>
                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.siblings}>
                            <Column header='Sl.No' className='ma-w100 ma-h100' body={(rowData, index) => {
                                return (<span>{index.rowIndex + 1}</span>)
                            }} />
                            <Column header="Name" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        value={this.state.siblings[index.rowIndex].name}
                                        width={250}
                                        placeholder="Enter Name"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "name", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="Gender" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.genderData} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].gender}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "gender", "siblings")}
                                        placeholder="Select Gender" />
                                )
                            }} />
                            <Column header="Class Studying" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.classStudyingDrp} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].classStudying}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "classStudying", "siblings")}
                                        placeholder="Select Class" />
                                )
                            }} />
                            <Column header="School Studying" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].schoolStudying}
                                        placeholder="Enter School Studying"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "schoolStudying", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="" body={(rowData, index) => {
                                return (
                                    <div className="flex flex-column align-items-center justify-content-center gap-2">
                                        <Button icon="pi pi-plus" aria-label="Increase" onClick={() => this.onCliclAddSibling(true, index.rowIndex)} />
                                        {this.state.siblings.length > 1 && <Button icon="pi pi-minus" aria-label="Decrease" onClick={() => this.onCliclAddSibling(false, index.rowIndex)} />}
                                    </div>
                                )
                            }} />
                        </DataTable>
                    </div>

                    {/* ADDRESS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black ' style={{ color: 'black' }}>
                            <u>Address</u>
                        </h1>
                    </div>
                    {/* <br /> */}
                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        {/* Address Line */}
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Address Line<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    width={1300}
                                    // style={{ width: '100vw' }} // Updated to use 100%
                                    className="add-vehicle-field-input w-full"
                                    value={registration.addressLine}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'addressLine',
                                            this,
                                            formFields,
                                            registration,
                                            formValidations,
                                            'registration',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Enter Address Line"
                                />
                            </div>
                            {formValidations && !formValidations.fields['addressLine']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['addressLine']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    {/* state, district, pincode */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Pincode<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    className='add-vehicle-field-input w-full'
                                    value={registration.pinCode}
                                    width={250}
                                    onChange={(e) => this.onPincodeChange(e.target.value)}
                                    placeholder="Enter Pincode (6 digits)"
                                    keyfilter='int'
                                    maxLength={6}

                                />
                            </div>
                            {formValidations && !formValidations.fields['pinCode']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['pinCode']?.errorMsg}</p>
                            )}
                        </div>

                        <div className="col-span-1  ">
                            <p className='transport-fee-form-label'>State<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={registration.state}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.state} // Add the options from state
                                    onChange={(e) => this.onStateChange(e.target.value)}
                                    placeholder="Select State"
                                />
                            </div>
                            {formValidations && !formValidations.fields['state']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['state']?.errorMsg}</p>
                            )}
                        </div>


                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>City/District<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={registration.cityOrDist}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.cityOrDist} // Add the options from state
                                    onChange={(e) =>
                                        onDropDownChange(
                                            e.target.value,
                                            'cityOrDist',
                                            this,
                                            formFields,
                                            registration,
                                            formValidations,
                                            'registration',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Select City/District"
                                />
                            </div>
                            {formValidations && !formValidations.fields['cityOrDist']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['cityOrDist']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">

                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">

                        <div className="col-span-1 flex align-items-center">
                            <input
                                type="checkbox"
                                id="transportRequired"
                                checked={!!registration.transportRequired}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    this.setState({
                                        registration: {
                                            ...registration,
                                            transportRequired: checked,
                                            requestedStop: checked ? registration.requestedStop : '' // Clear requestedStop if unchecked
                                        }
                                    });
                                    // Optionally, clear validation error for requestedStop when unchecked
                                    if (!checked) {
                                        this.setState(prevState => ({
                                            formValidations: {
                                                ...prevState.formValidations,
                                                fields: {
                                                    ...prevState.formValidations.fields,
                                                    requestedStop: {
                                                        isValid: true,
                                                        errorMsg: ''
                                                    }
                                                }
                                            }
                                        }));
                                    }
                                }}
                                style={{ width: 18, height: 18, marginRight: 8 }}
                            />
                            <label htmlFor="transportRequired" className='transport-fee-form-label'>Transport Required</label>
                        </div>


                    </div>

                    {/* Conditionally Render Requested Stop Dropdown */}
                    {registration.transportRequired && (

                        <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="">
                                <p className='transport-fee-form-label'>Requested Stop<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={registration.requestedStop}
                                        onChange={(e) =>
                                            onTextChange(
                                                e.target.value,
                                                'requestedStop',
                                                this,
                                                formFields,
                                                registration,
                                                formValidations,
                                                'registration',
                                                'formValidations'
                                            )
                                        }
                                        placeholder='Enter Requested Stop'
                                    />
                                </div>
                                {formValidations && !formValidations.fields['requestedStop']?.isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['requestedStop']?.errorMsg}</p>
                                )}
                            </div>
                        </div>

                    )}



                    {/* </div > */}

                    <div className="text-center mt-8">

                        {this.state.isShowPayFeeButton && !this.state?.isRegistrationFeePaid &&
                            (<Button
                                disabled={this.state.isRegistrationFeePaid ? true : false}
                                className='confirmDialogAcceptBtn mr-5 w-18rem p-5' style={{ paddingLeft: 20, width: 200 }}
                                onClick={() => this.openDailogPayAppFee()}
                            >
                                Pay Registration Fee
                            </Button>)
                        }
                        {this.state?.isRegistrationFeePaid &&
                            (
                                <Button icon={' text-lg '} label={!this.state.isEdit ? 'Save ' : 'Save '} onClick={() => !this.state.isEdit ? this.onSubmitApplication(true) : this.onSubmitApplication(false)} className='confirmDialogAcceptBtn  mr-5 w-18rem p-5' />
                            )}

                        {!this.state.isEdit && this.state?.isRegistrationFeePaid && <Button icon={' text-lg '} label='Save and Proceed to Next Step' onClick={() => this.onSubmitApplication(true, true)} className='confirmDialogAcceptBtn  mr-5 w-24rem p-5' />}

                        <Button label='Cancel'
                            style={{
                                background: '#E6E8EA', border: '0px', borderRadius: '12px', maxHeight: '48px', width: '120px', font: "InterSemiBold !important",
                                fontSize: '16px', color: 'black'
                            }}
                            className='confirmDialogCancelBtn p-5' onClick={() => !this.state.isEdit ? this.props.navigate('/admission-registration') : this.setState({ isEdit: false }, () => this.props.onHandleClose())} />

                    </div>
                </div>

                <Dialog
                    isopen={this.state.isOpenPayFeeDailog}
                    visible={this.state.isOpenPayFeeDailog}
                    className="pay-fee"
                    style={{ position: 'fixed', right: '0' }}
                    draggable={false}
                    onHide={this.onHandleCancelPayFee}
                    closable={false}
                    header={() => {
                        return (<div className='mt-2 mb-4'>
                            <h3 className="formhead text-center ">Pay Fee</h3>

                        </div>)
                    }}
                >
                    <div className="mb-5 ml-5 mr-5">
                        <div>
                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='term'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Fee Type name"
                                        value={`${this.state.feePayInfo?.feeName || ""}`}
                                        disabled={true}
                                        onChange={(e) => onTextChange(e.target.value, 'FeeTypeName', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                    />
                                </div>
                                {payFormValidations && !payFormValidations.fields['FeeTypeName'].isValid && <p className="p-error">{payFormValidations.fields['FeeTypeName'].errorMsg}</p>}
                            </div>

                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='feeAmount'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Fee Amount"
                                        disabled={true}
                                        value={`${Number(this.state.feePayInfo?.amount) || 0}`}
                                        onChange={(e) => onTextChange(e.target.value, 'feeAmount', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}

                                    />
                                </div>
                                {payFormValidations && !payFormValidations.fields['feeAmount'].isValid && <p className="p-error">{payFormValidations.fields['feeAmount'].errorMsg}</p>}
                            </div>
                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetDropdown
                                        id='paymentType'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        options={this.state.paymentModes}
                                        value={payFeeFormData.paymentType}
                                        onChange={(e) => { onDropDownChange(e.target.value, 'paymentType', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations) }}
                                        placeholder={(
                                            <div>
                                                <span className=''>Payment Type</span>
                                            </div>
                                        )}
                                    />
                                </div>
                                {payFormValidations && !payFormValidations.fields['paymentType'].isValid && <p className="p-error">{payFormValidations.fields['paymentType'].errorMsg}</p>}
                            </div>
                            {(
                                // payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' || 
                                payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f'
                                // payFeeFormData.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
                            ) &&
                                <div className="col-12">
                                    <label className='label mb-2 '>Transaction Id<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Transaction Id"
                                            value={this.state.transctionId}
                                            onChange={(e) => this.setState({ transctionId: e.target.value })}

                                        />
                                    </div>

                                </div>
                            }
                            {payFeeFormData.paymentType &&
                                <div className="col-12">
                                    <label className='label mb-2 '>Remarks<span className='ma-required'></span></label>
                                    <div className="mt-2">
                                        <ClassetTextArea
                                            id='feeType'
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Remarks"
                                            value={payFeeFormData.remarks}
                                            onChange={(e) => onTextChange(e.target.value, 'remarks', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}

                                        />
                                    </div>

                                </div>
                            }
                            <div className='flex justify-content-center mb-4 mt-4'>

                                <Button className='formSubmitButtonn mr-2' style={{ borderRadius: '12px', fontSize: '16px', backgroundColor: '#076EFF' }}
                                    // onClick={this.OnPayFee}
                                    onClick={this.handlePayment}
                                >
                                    <AddIcon2 />
                                    <p className='formSubmitButtonnText'>Pay Now</p>
                                </Button>
                                <Button className='cancelButtonn w-4'
                                    onClick={this.onHandleCancelPayFee} >

                                    <p className='cancelButtonnText'>Cancel</p>
                                </Button>
                            </div>
                        </div>
                    </div>


                </Dialog>
                {
                    this.state.isShowReceipt && <FeeReciept receiptData={this.state?.receiptInfo} hideFeeReciept={() => {
                        this.setState({
                            isShowReceipt: false,
                            receiptInfo: {}
                        })

                    }} />
                }
                {/* {this.state.showNTTPayment && this.state.nttPaymentData && ( */}
                <NTTPaymentComponent
                    showPaymentButton={this.state.showNTTPayment}
                    paymentData={this.state.nttPaymentData}
                    onPaymentSuccess={this.onNTTPaymentSuccess}
                    onPaymentError={this.onNTTPaymentError}
                    onPaymentCancel={this.onNTTPaymentCancel}
                />
                {/* )} */}
                {
                    this.state.isLoading && <>
                        <LoadingComponent />
                    </>
                }

                <Toast ref={(el) => this.toast = el} position="bottom-right" />


            </>
        );
    }
}
const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(Authentication(withRouter(CreateRegistration)));

const gradePriorityOptions = Object.entries(gradesEnum).map(([label, value]) => ({
    //   label: `${label} (Priority: ${value})`,
    label: `${label}`,
    value: value
}));